
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime
} = require('./runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.19.1
 * Query Engine version: 69d742ee20b815d88e17e54db4a2a7a3b30324e3
 */
Prisma.prismaVersion = {
  client: "5.19.1",
  engine: "69d742ee20b815d88e17e54db4a2a7a3b30324e3"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.A4cContractPaymentStatusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  paymentStatus: 'paymentStatus',
  contractId: 'contractId'
};

exports.Prisma.A4cContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mtId: 'mtId',
  salesForceId: 'salesForceId',
  vatRate: 'vatRate',
  rate: 'rate',
  frequency: 'frequency',
  paymentDelay: 'paymentDelay',
  delegatedPassengersToInvoice: 'delegatedPassengersToInvoice',
  revenueCategory: 'revenueCategory',
  clientCategory: 'clientCategory',
  startDate: 'startDate',
  endDate: 'endDate'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lat: 'lat',
  lng: 'lng',
  houseNumber: 'houseNumber',
  street: 'street',
  zipcode: 'zipcode',
  inseeCode: 'inseeCode',
  city: 'city',
  formattedAddress: 'formattedAddress'
};

exports.Prisma.AssociatedMedicalTransporterScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mtId: 'mtId',
  associateId: 'associateId',
  associateLabel: 'associateLabel'
};

exports.Prisma.BookingRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sentAt: 'sentAt',
  resendAt: 'resendAt',
  lastResendAt: 'lastResendAt',
  slug: 'slug',
  status: 'status',
  lastStatusUpdate: 'lastStatusUpdate',
  protectionDuration: 'protectionDuration',
  protectionExpiration: 'protectionExpiration',
  canPrebook: 'canPrebook',
  mtId: 'mtId',
  bundleId: 'bundleId',
  bundleRuleId: 'bundleRuleId',
  counterOfferMaxEarlyDeparture: 'counterOfferMaxEarlyDeparture',
  counterOfferMaxLateDeparture: 'counterOfferMaxLateDeparture',
  counterOfferMaxEarlyArrival: 'counterOfferMaxEarlyArrival',
  counterOfferRoundName: 'counterOfferRoundName',
  counterOfferRoundIndex: 'counterOfferRoundIndex',
  isTcAnswered: 'isTcAnswered',
  isAutoDispatched: 'isAutoDispatched',
  numberOfRecentPassengers: 'numberOfRecentPassengers',
  alternativeDepartureTime: 'alternativeDepartureTime',
  dispatchAlgorithm: 'dispatchAlgorithm',
  roundIndex: 'roundIndex',
  placeInQueue: 'placeInQueue',
  isFallback: 'isFallback',
  autoAcceptedAtRoundName: 'autoAcceptedAtRoundName',
  autoAcceptedAtRoundIndex: 'autoAcceptedAtRoundIndex',
  parentId: 'parentId',
  missionId: 'missionId',
  userId: 'userId',
  answeredByTcId: 'answeredByTcId',
  lastResentById: 'lastResentById',
  thirdPartyPlatform: 'thirdPartyPlatform',
  thirdPartyId: 'thirdPartyId',
  thirdPartyQueuedAt: 'thirdPartyQueuedAt',
  thirdPartyPostedAt: 'thirdPartyPostedAt',
  thirdPartyCancelledAt: 'thirdPartyCancelledAt'
};

exports.Prisma.BrowserExtensionConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  url: 'url',
  deliveryType: 'deliveryType',
  useOriginAsNewPatientAddress: 'useOriginAsNewPatientAddress'
};

exports.Prisma.BundleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  type: 'type',
  vehicle: 'vehicle',
  indexes: 'indexes',
  disabled: 'disabled',
  mfId: 'mfId',
  parentBundleId: 'parentBundleId',
  dispatcherId: 'dispatcherId',
  isReserve: 'isReserve',
  mtToContactCount: 'mtToContactCount',
  mtId: 'mtId',
  preconfiguredTdrId: 'preconfiguredTdrId',
  fallbackTdrId: 'fallbackTdrId',
  fallbackToParentTdr: 'fallbackToParentTdr',
  rotationFirstWeekDate: 'rotationFirstWeekDate',
  rotationWeeksInterval: 'rotationWeeksInterval'
};

exports.Prisma.BundleMtRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mtId: 'mtId',
  weight: 'weight',
  shouldPrebook: 'shouldPrebook',
  bundleRuleId: 'bundleRuleId'
};

exports.Prisma.BundleRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  bundleId: 'bundleId',
  preconfiguredTdrId: 'preconfiguredTdrId',
  dispatchAlgorithm: 'dispatchAlgorithm',
  mtSelectionType: 'mtSelectionType',
  preferRecentMts: 'preferRecentMts',
  shouldBroadcast: 'shouldBroadcast',
  precision: 'precision',
  source: 'source',
  maxNumberOfMts: 'maxNumberOfMts',
  checkContract: 'checkContract',
  counterOfferMaxEarlyDeparture: 'counterOfferMaxEarlyDeparture',
  counterOfferMaxLateDeparture: 'counterOfferMaxLateDeparture',
  counterOfferMaxEarlyArrival: 'counterOfferMaxEarlyArrival',
  type: 'type',
  shortProtectionDuration: 'shortProtectionDuration',
  longProtectionDuration: 'longProtectionDuration'
};

exports.Prisma.CancelOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  ownerId: 'ownerId',
  mfuId: 'mfuId'
};

exports.Prisma.ChangeRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  mtId: 'mtId',
  slug: 'slug',
  deadline: 'deadline'
};

exports.Prisma.CreditNoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invoiceId: 'invoiceId',
  creditNoteSequenceNumber: 'creditNoteSequenceNumber',
  primaryKey: 'primaryKey'
};

exports.Prisma.AllowPreferredMtForPayerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payer: 'payer',
  customizationId: 'customizationId'
};

exports.Prisma.CustomizationScalarFieldEnum = {
  id: 'id',
  patientNirState: 'patientNirState',
  patientNirLabel: 'patientNirLabel',
  patientIppState: 'patientIppState',
  patientIppLabel: 'patientIppLabel',
  patientBirthdateState: 'patientBirthdateState',
  patientBirthdateLabel: 'patientBirthdateLabel',
  patientBirthnameState: 'patientBirthnameState',
  patientBirthnameLabel: 'patientBirthnameLabel',
  patientPhoneState: 'patientPhoneState',
  patientPhoneLabel: 'patientPhoneLabel',
  patientRoomState: 'patientRoomState',
  patientRoomLabel: 'patientRoomLabel',
  patientVisitIdState: 'patientVisitIdState',
  patientVisitIdLabel: 'patientVisitIdLabel',
  patientAddressState: 'patientAddressState',
  patientAddressLabel: 'patientAddressLabel',
  patientAddressDetailsState: 'patientAddressDetailsState',
  patientAddressDetailsLabel: 'patientAddressDetailsLabel',
  ambulanceLabel: 'ambulanceLabel',
  vslLabel: 'vslLabel',
  tpmrLabel: 'tpmrLabel',
  bariatricLabel: 'bariatricLabel',
  paramedicalLabel: 'paramedicalLabel',
  medicalLabel: 'medicalLabel',
  missionMfuNotesState: 'missionMfuNotesState',
  missionMfuNotesLabel: 'missionMfuNotesLabel',
  missionDoctorState: 'missionDoctorState',
  missionDoctorLabel: 'missionDoctorLabel',
  missionChoiceForPayersLabel: 'missionChoiceForPayersLabel'
};

exports.Prisma.DeviceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hardwareIdentifier: 'hardwareIdentifier',
  deviceIdentifier: 'deviceIdentifier',
  product: 'product',
  webpushSubscription: 'webpushSubscription',
  fcmToken: 'fcmToken',
  appBundleVersion: 'appBundleVersion',
  appVersion: 'appVersion',
  type: 'type',
  os: 'os',
  browserName: 'browserName',
  browserVersion: 'browserVersion',
  hardware: 'hardware',
  state: 'state',
  userId: 'userId'
};

exports.Prisma.DistanceMapScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.DistanceMapEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fromInsee: 'fromInsee',
  toInsee: 'toInsee',
  meters: 'meters',
  distanceMapId: 'distanceMapId'
};

exports.Prisma.DoctorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  rpps: 'rpps',
  firstname: 'firstname',
  lastname: 'lastname',
  parentDoctorId: 'parentDoctorId',
  hasSignature: 'hasSignature',
  disabled: 'disabled',
  disabledAt: 'disabledAt'
};

exports.Prisma.DriverEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  firedAt: 'firedAt',
  geopoint: 'geopoint',
  mtId: 'mtId',
  passengerId: 'passengerId'
};

exports.Prisma.ElisaConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  username: 'username',
  password: 'password',
  apiKey: 'apiKey',
  url: 'url'
};

exports.Prisma.OptOutScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sender: 'sender',
  emailAddressId: 'emailAddressId'
};

exports.Prisma.EmailAddressScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  emailAddress: 'emailAddress',
  blockedAt: 'blockedAt'
};

exports.Prisma.ExportRequestScalarFieldEnum = {
  id: 'id',
  hash: 'hash',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
  requestedById: 'requestedById',
  exportType: 'exportType',
  processingAt: 'processingAt',
  processedAt: 'processedAt',
  ravenId: 'ravenId',
  context: 'context',
  patientId: 'patientId',
  extra: 'extra'
};

exports.Prisma.ExportRequestOutputScalarFieldEnum = {
  id: 'id',
  url: 'url',
  filename: 'filename',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  requestId: 'requestId'
};

exports.Prisma.FinessMedicalFacilityScalarFieldEnum = {
  id: 'id',
  structureet: 'structureet',
  nofinesset: 'nofinesset',
  nofinessej: 'nofinessej',
  rs: 'rs',
  rslongue: 'rslongue',
  complrs: 'complrs',
  compldistrib: 'compldistrib',
  numvoie: 'numvoie',
  typvoie: 'typvoie',
  voie: 'voie',
  compvoie: 'compvoie',
  lieuditbp: 'lieuditbp',
  commune: 'commune',
  departement: 'departement',
  libdepartement: 'libdepartement',
  ligneacheminement: 'ligneacheminement',
  telephone: 'telephone',
  telecopie: 'telecopie',
  categetab: 'categetab',
  libcategetab: 'libcategetab',
  categagretab: 'categagretab',
  libcategagretab: 'libcategagretab',
  siret: 'siret',
  codeape: 'codeape',
  codemft: 'codemft',
  libmft: 'libmft',
  codesph: 'codesph',
  libsph: 'libsph',
  dateouv: 'dateouv',
  dateautor: 'dateautor',
  datemaj: 'datemaj',
  numuai: 'numuai',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FlatFeeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  price: 'price',
  pricingId: 'pricingId'
};

exports.Prisma.GlobalStoreEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  value: 'value'
};

exports.Prisma.InvoiceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  finalizedAt: 'finalizedAt',
  status: 'status',
  invoiceSequenceNumber: 'invoiceSequenceNumber',
  primaryKey: 'primaryKey',
  agreementId: 'agreementId',
  price: 'price',
  priceWithVat: 'priceWithVat',
  vat: 'vat',
  replacedInvoiceId: 'replacedInvoiceId',
  mfId: 'mfId',
  mtId: 'mtId',
  mtDeadline: 'mtDeadline',
  mfDeadline: 'mfDeadline',
  startDate: 'startDate',
  endDate: 'endDate',
  assignedInvoicerId: 'assignedInvoicerId'
};

exports.Prisma.InvoiceEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  byId: 'byId',
  invoiceId: 'invoiceId'
};

exports.Prisma.InvoicePassengerBlockScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  price: 'price',
  priceInfoId: 'priceInfoId',
  passengerId: 'passengerId',
  tripBlockId: 'tripBlockId'
};

exports.Prisma.InvoiceTripBlockScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  price: 'price',
  tripId: 'tripId',
  invoiceId: 'invoiceId'
};

exports.Prisma.ManualInvoiceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  finalizedAt: 'finalizedAt',
  status: 'status',
  mtInvoiceReference: 'mtInvoiceReference',
  prefix: 'prefix',
  hasDocument: 'hasDocument',
  mfId: 'mfId',
  mtId: 'mtId',
  price: 'price',
  priceWithVat: 'priceWithVat',
  vat: 'vat',
  replacedManualInvoiceId: 'replacedManualInvoiceId',
  mfDeadline: 'mfDeadline',
  assignedManualInvoicerId: 'assignedManualInvoicerId',
  refuseReason: 'refuseReason',
  refuseComment: 'refuseComment'
};

exports.Prisma.ManualInvoiceEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  byId: 'byId',
  manualInvoiceId: 'manualInvoiceId'
};

exports.Prisma.MedicalFacilityScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  corporateName: 'corporateName',
  phone: 'phone',
  email: 'email',
  finess: 'finess',
  legalFiness: 'legalFiness',
  epmsiFiness: 'epmsiFiness',
  timezone: 'timezone',
  visitIdPattern: 'visitIdPattern',
  capacity: 'capacity',
  category: 'category',
  mfgId: 'mfgId',
  placeId: 'placeId',
  sihId: 'sihId',
  administrativeReference: 'administrativeReference',
  tcNoteLink: 'tcNoteLink',
  hasSignature: 'hasSignature',
  siret: 'siret',
  vatId: 'vatId',
  invoicingAddressRaw: 'invoicingAddressRaw',
  invoicingAddressStreet: 'invoicingAddressStreet',
  invoicingAddressCity: 'invoicingAddressCity',
  invoicingAddressZipcode: 'invoicingAddressZipcode',
  chorusCode: 'chorusCode',
  accountingAdministrativeReference: 'accountingAdministrativeReference',
  invoicePrefix: 'invoicePrefix',
  apiPasswordHash: 'apiPasswordHash',
  needManualInvoice: 'needManualInvoice',
  needStretcherMod: 'needStretcherMod',
  lastSalesForceSync: 'lastSalesForceSync',
  salesForceId: 'salesForceId',
  salesForceOwnerName: 'salesForceOwnerName',
  sageId: 'sageId',
  pennylaneCustomerId: 'pennylaneCustomerId',
  hasSoftwareHcContract: 'hasSoftwareHcContract',
  hasSoftwareAldContract: 'hasSoftwareAldContract',
  hasInvoicingContract: 'hasInvoicingContract',
  hasRegulationContract: 'hasRegulationContract',
  hasNaContract: 'hasNaContract',
  speedcallUsername: 'speedcallUsername',
  atlasId: 'atlasId',
  sigemsS3Bucket: 'sigemsS3Bucket',
  hprimConfigId: 'hprimConfigId',
  syncUserConfigId: 'syncUserConfigId'
};

exports.Prisma.MedicalFacilityDepartmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  floor: 'floor',
  phone: 'phone',
  email: 'email',
  speciality: 'speciality',
  capacity: 'capacity',
  description: 'description',
  type: 'type',
  addressId: 'addressId',
  mfId: 'mfId',
  ptahCodSrv: 'ptahCodSrv',
  thirdPartyId: 'thirdPartyId'
};

exports.Prisma.MedicalFacilityApiScopeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ownerMfId: 'ownerMfId',
  mfId: 'mfId'
};

exports.Prisma.MedicalFacilityGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.MedicalFacilityGroupAclScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  mfgId: 'mfgId',
  canWrite: 'canWrite',
  canRead: 'canRead'
};

exports.Prisma.MedicalFacilityUnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  shortName: 'shortName',
  mfId: 'mfId',
  originHistory: 'originHistory',
  destinationHistory: 'destinationHistory',
  needAmbulance: 'needAmbulance',
  needVsl: 'needVsl',
  needTpmr: 'needTpmr',
  needBariatric: 'needBariatric',
  needParamedical: 'needParamedical',
  needMedical: 'needMedical',
  needLdd: 'needLdd',
  lddTransportCapacity: 'lddTransportCapacity',
  lddDispatchType: 'lddDispatchType',
  needPatientReminder: 'needPatientReminder',
  patientReminderType: 'patientReminderType',
  needAsyncMissionCreation: 'needAsyncMissionCreation',
  needSplitMissions: 'needSplitMissions',
  needOptimization: 'needOptimization',
  needInboundPickupTimeChange: 'needInboundPickupTimeChange',
  needPayerDisplay: 'needPayerDisplay',
  needExports: 'needExports',
  needIncidents: 'needIncidents',
  needValidateGovFlatRates: 'needValidateGovFlatRates',
  needOrderButton: 'needOrderButton',
  needDematerializedPmt: 'needDematerializedPmt',
  needPmtSignature: 'needPmtSignature',
  needCerfaImport: 'needCerfaImport',
  needFlatRateOnArt80Pmt: 'needFlatRateOnArt80Pmt',
  needMtOnArt80Pmt: 'needMtOnArt80Pmt',
  needVisitIdOnArt80Pmt: 'needVisitIdOnArt80Pmt',
  needTc: 'needTc',
  needRegulation: 'needRegulation',
  needMonitoring: 'needMonitoring',
  needPriorityDispatch: 'needPriorityDispatch',
  needAutoOrder: 'needAutoOrder',
  needPooling: 'needPooling',
  needDelayedDispatch: 'needDelayedDispatch',
  needCancelPastOrder: 'needCancelPastOrder',
  mtRefusalHours: 'mtRefusalHours',
  needOtherMfPassengers: 'needOtherMfPassengers',
  hospitalType: 'hospitalType',
  placeId: 'placeId',
  customizationId: 'customizationId',
  transportReasonTemplate: 'transportReasonTemplate',
  thirdPartyId: 'thirdPartyId'
};

exports.Prisma.MedicalTransporterScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabledAt: 'enabledAt',
  lastBookingRequestAt: 'lastBookingRequestAt',
  type: 'type',
  name: 'name',
  hasVsl: 'hasVsl',
  hasAmbulance: 'hasAmbulance',
  hasTaxi: 'hasTaxi',
  hasBariatric: 'hasBariatric',
  hasTpmr: 'hasTpmr',
  hasParamedical: 'hasParamedical',
  hasMedical: 'hasMedical',
  vehicleCount: 'vehicleCount',
  phonesByVehicle: 'phonesByVehicle',
  partnership: 'partnership',
  addressId: 'addressId',
  invoicingPhones: 'invoicingPhones',
  lastBrPhoneRavenId: 'lastBrPhoneRavenId',
  holidayStart: 'holidayStart',
  holidayEnd: 'holidayEnd',
  robotConfigId: 'robotConfigId',
  extensionConfigId: 'extensionConfigId',
  useGtweb: 'useGtweb',
  useElisa: 'useElisa',
  useSaphyr: 'useSaphyr',
  elisaConfigId: 'elisaConfigId',
  gtwebCredentials: 'gtwebCredentials',
  saphyrCredentials: 'saphyrCredentials',
  useAppsolu: 'useAppsolu',
  appsoluGroupmentCId: 'appsoluGroupmentCId',
  dispatchSoftware: 'dispatchSoftware',
  isDispatcher: 'isDispatcher',
  ambulanceFlatFeeType: 'ambulanceFlatFeeType',
  tapFlatFeeType: 'tapFlatFeeType',
  flatFeeTypeZone: 'flatFeeTypeZone',
  govPricingType: 'govPricingType',
  siret: 'siret',
  siretClosedAt: 'siretClosedAt',
  vatId: 'vatId',
  invoicingAddressRaw: 'invoicingAddressRaw',
  invoicingAddressStreet: 'invoicingAddressStreet',
  invoicingAddressCity: 'invoicingAddressCity',
  invoicingAddressZipcode: 'invoicingAddressZipcode',
  legalForm: 'legalForm',
  corporateName: 'corporateName',
  shareCapital: 'shareCapital',
  mustValidateTrips: 'mustValidateTrips',
  passengerVerificationScope: 'passengerVerificationScope',
  apiPasswordHash: 'apiPasswordHash',
  needManualInvoice: 'needManualInvoice',
  lastSalesForceSync: 'lastSalesForceSync',
  salesForceId: 'salesForceId',
  salesForceOwnerName: 'salesForceOwnerName',
  sageId: 'sageId',
  pennylaneCustomerId: 'pennylaneCustomerId',
  hasA4cContract: 'hasA4cContract',
  hasTdrContract: 'hasTdrContract',
  hasNaContract: 'hasNaContract',
  hasGeoLocContract: 'hasGeoLocContract',
  shouldSuggestMobileApp: 'shouldSuggestMobileApp',
  shouldForceSms: 'shouldForceSms',
  includeInGovTdr: 'includeInGovTdr',
  spsCode: 'spsCode'
};

exports.Prisma.MedicalTransporterAclScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  invitedEmail: 'invitedEmail',
  mtId: 'mtId',
  canWrite: 'canWrite',
  canRead: 'canRead'
};

exports.Prisma.MedicalTransporterReportScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  invoiceId: 'invoiceId',
  mtId: 'mtId',
  mfId: 'mfId',
  vehicle: 'vehicle',
  patientLastName: 'patientLastName',
  patientFirstName: 'patientFirstName',
  originId: 'originId',
  destinationId: 'destinationId',
  outboundDepartureTime: 'outboundDepartureTime',
  inboundDepartureTime: 'inboundDepartureTime',
  patientGender: 'patientGender',
  transportReason: 'transportReason',
  userId: 'userId',
  assignedTcId: 'assignedTcId',
  declineReason: 'declineReason',
  declineDetails: 'declineDetails'
};

exports.Prisma.MedicalTransporterReviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  details: 'details',
  passengerId: 'passengerId',
  userId: 'userId'
};

exports.Prisma.MissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  bookedAt: 'bookedAt',
  confirmedAt: 'confirmedAt',
  type: 'type',
  workingMinutesAvailableToDispatch: 'workingMinutesAvailableToDispatch',
  stopManualDispatchAt: 'stopManualDispatchAt',
  stopPriorityDispatchAt: 'stopPriorityDispatchAt',
  stopAutoDispatchAt: 'stopAutoDispatchAt',
  initialStatus: 'initialStatus',
  status: 'status',
  deadline: 'deadline',
  assignedTcId: 'assignedTcId',
  ownerId: 'ownerId',
  mergedIntoId: 'mergedIntoId',
  vehicle: 'vehicle',
  preferredMtId: 'preferredMtId',
  canReplaceMt: 'canReplaceMt',
  shouldMtWait: 'shouldMtWait',
  details: 'details',
  mfuNotes: 'mfuNotes',
  tcNote: 'tcNote',
  replacedMissionId: 'replacedMissionId',
  chosenMtId: 'chosenMtId',
  chosenIntermediateMtId: 'chosenIntermediateMtId',
  closestMt: 'closestMt',
  fallbackTdrLaunchedAt: 'fallbackTdrLaunchedAt',
  secondFallbackTdrLaunchedAt: 'secondFallbackTdrLaunchedAt'
};

exports.Prisma.MissionEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  otherFields: 'otherFields',
  byId: 'byId',
  missionId: 'missionId'
};

exports.Prisma.IncludedPassengerStatusScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  optimizationRequestId: 'optimizationRequestId'
};

exports.Prisma.ExcludedPassengerIdScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  passengerId: 'passengerId',
  optimizationRequestId: 'optimizationRequestId'
};

exports.Prisma.OptimizationRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  successAt: 'successAt',
  failedAt: 'failedAt',
  isMain: 'isMain',
  type: 'type',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
  extra: 'extra',
  prevOptimId: 'prevOptimId',
  shouldDeprecateOptimTemplates: 'shouldDeprecateOptimTemplates',
  mfuId: 'mfuId',
  auralRecap: 'auralRecap'
};

exports.Prisma.OptimizationRequestRowScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  requestId: 'requestId',
  passengerId: 'passengerId',
  poolingGroup: 'poolingGroup',
  chainGroup: 'chainGroup',
  departureTime: 'departureTime',
  arrivalTime: 'arrivalTime',
  detour: 'detour',
  detourDistance: 'detourDistance',
  waitingTime: 'waitingTime',
  pooledDistance: 'pooledDistance',
  vehicle: 'vehicle',
  auralRecap: 'auralRecap'
};

exports.Prisma.OrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  ownerId: 'ownerId',
  mfuId: 'mfuId',
  isPmtOrder: 'isPmtOrder',
  isPastOrder: 'isPastOrder',
  toBeCompleted: 'toBeCompleted',
  isClone: 'isClone',
  autoRenew: 'autoRenew',
  endlessPeriodStartDate: 'endlessPeriodStartDate',
  endlessPeriodEndDate: 'endlessPeriodEndDate',
  mtReportId: 'mtReportId'
};

exports.Prisma.OrderItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  replacedOrderItemId: 'replacedOrderItemId',
  vehicle: 'vehicle',
  originId: 'originId',
  originServiceRaw: 'originServiceRaw',
  originMfdId: 'originMfdId',
  destinationId: 'destinationId',
  destinationServiceRaw: 'destinationServiceRaw',
  destinationMfdId: 'destinationMfdId',
  isSameMfdType: 'isSameMfdType',
  preferredMtId: 'preferredMtId',
  canReplaceMt: 'canReplaceMt',
  shouldMtWait: 'shouldMtWait',
  details: 'details',
  mfuNotes: 'mfuNotes',
  doctorId: 'doctorId',
  orderId: 'orderId',
  appointmentId: 'appointmentId',
  toBeCompleted: 'toBeCompleted',
  missionId: 'missionId',
  replacedMissionId: 'replacedMissionId'
};

exports.Prisma.OrderPatientScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  patientId: 'patientId',
  transportReason: 'transportReason',
  reason: 'reason',
  isAccompanied: 'isAccompanied',
  hasNoSocialSecurityNumber: 'hasNoSocialSecurityNumber',
  specificNeeds: 'specificNeeds',
  patientCondition: 'patientCondition',
  patientVisitId: 'patientVisitId',
  payer: 'payer',
  pmtIssuer: 'pmtIssuer'
};

exports.Prisma.OrderRideScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  direction: 'direction',
  timeReference: 'timeReference',
  chosenDate: 'chosenDate',
  estimatedDuration: 'estimatedDuration',
  estimatedDistance: 'estimatedDistance',
  billingDistance: 'billingDistance',
  departureTime: 'departureTime',
  arrivalTime: 'arrivalTime',
  tollFees: 'tollFees',
  dismissed: 'dismissed',
  orderItemId: 'orderItemId',
  originalDepartureTime: 'originalDepartureTime',
  originalArrivalTime: 'originalArrivalTime'
};

exports.Prisma.PassengerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  relationKey: 'relationKey',
  otherPassengerId: 'otherPassengerId',
  tripId: 'tripId',
  status: 'status',
  payment: 'payment',
  payer: 'payer',
  pmtIssuer: 'pmtIssuer',
  govFlatRate: 'govFlatRate',
  govFlatRatePrice: 'govFlatRatePrice',
  isGovFlatRateVerified: 'isGovFlatRateVerified',
  govFlatRateVerificationStatus: 'govFlatRateVerificationStatus',
  govFlatRateLastUpdatedAt: 'govFlatRateLastUpdatedAt',
  govFlatRateLastSentAt: 'govFlatRateLastSentAt',
  doctorId: 'doctorId',
  patientId: 'patientId',
  isAccompanied: 'isAccompanied',
  transportReason: 'transportReason',
  reason: 'reason',
  specificNeeds: 'specificNeeds',
  patientCondition: 'patientCondition',
  isSameMfdType: 'isSameMfdType',
  mfuId: 'mfuId',
  ownerId: 'ownerId',
  requestedVehicle: 'requestedVehicle',
  preferredMtId: 'preferredMtId',
  canReplaceMt: 'canReplaceMt',
  shouldMtWait: 'shouldMtWait',
  details: 'details',
  mfuNotes: 'mfuNotes',
  patientVisitId: 'patientVisitId',
  direction: 'direction',
  initialTimeReference: 'initialTimeReference',
  timeReference: 'timeReference',
  initialDepartureTime: 'initialDepartureTime',
  initialArrivalTime: 'initialArrivalTime',
  departureTime: 'departureTime',
  arrivalTime: 'arrivalTime',
  mtUnbookDeadline: 'mtUnbookDeadline',
  timezone: 'timezone',
  estimatedDuration: 'estimatedDuration',
  estimatedDistance: 'estimatedDistance',
  billingDistance: 'billingDistance',
  invoiceableDistance: 'invoiceableDistance',
  tollFees: 'tollFees',
  price: 'price',
  originId: 'originId',
  originServiceRaw: 'originServiceRaw',
  originMfdId: 'originMfdId',
  destinationId: 'destinationId',
  destinationServiceRaw: 'destinationServiceRaw',
  destinationMfdId: 'destinationMfdId',
  replacedPassengerId: 'replacedPassengerId',
  needSplitManualInvoice: 'needSplitManualInvoice',
  prescriptionId: 'prescriptionId',
  thirdPartyPassengerId: 'thirdPartyPassengerId',
  amblerFees: 'amblerFees',
  tdrFees: 'tdrFees',
  a4cFees: 'a4cFees',
  a4hlFees: 'a4hlFees',
  aldFees: 'aldFees',
  needInboundDepartureTimeConfirmation: 'needInboundDepartureTimeConfirmation',
  inboundDepartureTimeConfirmedAt: 'inboundDepartureTimeConfirmedAt',
  orderId: 'orderId',
  appointmentId: 'appointmentId',
  isHandled: 'isHandled',
  spsId: 'spsId',
  replacedByOrderPatientId: 'replacedByOrderPatientId'
};

exports.Prisma.PassengerChangeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  passengerId: 'passengerId',
  requestedPassengerId: 'requestedPassengerId',
  willBreakPooling: 'willBreakPooling',
  isMajor: 'isMajor',
  changeRequestId: 'changeRequestId'
};

exports.Prisma.PassengerEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  otherFields: 'otherFields',
  byId: 'byId',
  passengerId: 'passengerId'
};

exports.Prisma.PassengerIncidentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  resolved: 'resolved',
  details: 'details',
  tcNote: 'tcNote',
  delay: 'delay',
  applyNoPatientFee: 'applyNoPatientFee',
  noPatientFeeAmount: 'noPatientFeeAmount',
  noPatientFee: 'noPatientFee',
  passengerId: 'passengerId',
  userId: 'userId',
  taskId: 'taskId'
};

exports.Prisma.PassengerPriceOverrideScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  extraLabel: 'extraLabel',
  extraPrice: 'extraPrice',
  price: 'price',
  noPatientFee: 'noPatientFee',
  passengerBlockId: 'passengerBlockId'
};

exports.Prisma.PatientScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ipp: 'ipp',
  lastname: 'lastname',
  firstname: 'firstname',
  birthname: 'birthname',
  gender: 'gender',
  birthdate: 'birthdate',
  phone: 'phone',
  phoneType: 'phoneType',
  room: 'room',
  visitId: 'visitId',
  nir: 'nir',
  socialSecurityRegion: 'socialSecurityRegion',
  healthInsuranceProvider: 'healthInsuranceProvider',
  mfId: 'mfId',
  sihPatientId: 'sihPatientId',
  addressId: 'addressId',
  addressDetails: 'addressDetails'
};

exports.Prisma.PlaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  gPlaceId: 'gPlaceId',
  keywords: 'keywords',
  mainText: 'mainText',
  secondaryText: 'secondaryText',
  iconType: 'iconType',
  gTypes: 'gTypes',
  url: 'url',
  addressId: 'addressId'
};

exports.Prisma.PrescriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  importedAt: 'importedAt',
  signedAt: 'signedAt',
  signedById: 'signedById',
  hash: 'hash',
  hashV2: 'hashV2',
  type: 'type',
  recyclable: 'recyclable',
  orderId: 'orderId',
  isPassengerlessPmt: 'isPassengerlessPmt',
  passengerSnapshot: 'passengerSnapshot',
  overrides: 'overrides',
  patientId: 'patientId',
  payer: 'payer',
  issuer: 'issuer',
  transportReason: 'transportReason',
  vehicle: 'vehicle',
  isOxygenNeeded: 'isOxygenNeeded',
  isProtectiveInsulationNeeded: 'isProtectiveInsulationNeeded',
  isRoundtrip: 'isRoundtrip',
  originId: 'originId',
  originServiceRaw: 'originServiceRaw',
  originMfdId: 'originMfdId',
  destinationId: 'destinationId',
  destinationServiceRaw: 'destinationServiceRaw',
  destinationMfdId: 'destinationMfdId',
  paperPatientFirstname: 'paperPatientFirstname',
  paperPatientLastname: 'paperPatientLastname',
  paperVehicle: 'paperVehicle',
  paperPatientBirthdate: 'paperPatientBirthdate',
  paperPatientNir: 'paperPatientNir',
  paperPatientAddress: 'paperPatientAddress',
  paperAld: 'paperAld',
  paperAtMp: 'paperAtMp',
  paperAtMpDate: 'paperAtMpDate',
  paperIsAccompanied: 'paperIsAccompanied',
  paperOriginAddress: 'paperOriginAddress',
  paperDestinationAddress: 'paperDestinationAddress',
  paperCapacity: 'paperCapacity',
  paperDoctorFullname: 'paperDoctorFullname',
  paperPrescribedAt: 'paperPrescribedAt',
  capacity: 'capacity',
  capacityUsed: 'capacityUsed',
  capacityLeft: 'capacityLeft',
  isExonerating: 'isExonerating',
  isModeratorTicketExempted: 'isModeratorTicketExempted',
  isRelatedToMilitaryDisabilityPension: 'isRelatedToMilitaryDisabilityPension',
  isFitForPooling: 'isFitForPooling',
  isAtMp: 'isAtMp',
  incidentDate: 'incidentDate',
  prescribedAt: 'prescribedAt',
  mfuId: 'mfuId',
  doctorId: 'doctorId'
};

exports.Prisma.PriceAgreementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  invoicingFrequency: 'invoicingFrequency',
  mfId: 'mfId',
  mtId: 'mtId',
  startDate: 'startDate',
  endDate: 'endDate',
  paymentModality: 'paymentModality',
  paymentDelay: 'paymentDelay',
  legalMentionDetails: 'legalMentionDetails',
  distanceMapId: 'distanceMapId',
  zoneMapId: 'zoneMapId',
  canMtEditDistance: 'canMtEditDistance',
  type: 'type',
  thirdPartyPaymentEnabled: 'thirdPartyPaymentEnabled',
  isReserve: 'isReserve'
};

exports.Prisma.PriceInfoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  passengerId: 'passengerId',
  pricingId: 'pricingId',
  functionName: 'functionName',
  km: 'km',
  kmToApplyPricePerKm: 'kmToApplyPricePerKm',
  pricePerKm: 'pricePerKm',
  kmPrice: 'kmPrice',
  flatFeeId: 'flatFeeId',
  shortTripFee: 'shortTripFee',
  shortTripKm: 'shortTripKm',
  shortTripRate: 'shortTripRate',
  baseTotal: 'baseTotal',
  incubator: 'incubator',
  airportStationPort: 'airportStationPort',
  extraTotal: 'extraTotal',
  datetimeRate: 'datetimeRate',
  departureTime: 'departureTime',
  arrivalTime: 'arrivalTime',
  timeSlot: 'timeSlot',
  timeSlotPrice: 'timeSlotPrice',
  govPriceRate: 'govPriceRate',
  govPriceRatePrice: 'govPriceRatePrice',
  taxiRate: 'taxiRate',
  taxiRatePrice: 'taxiRatePrice',
  toll: 'toll',
  patientCount: 'patientCount',
  poolingDiscountRate: 'poolingDiscountRate',
  poolingDiscountRatePrice: 'poolingDiscountRatePrice',
  waitingFee: 'waitingFee',
  noPatientFee: 'noPatientFee',
  isManual: 'isManual',
  total: 'total'
};

exports.Prisma.PricingVehicleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  vehicle: 'vehicle',
  pricingId: 'pricingId'
};

exports.Prisma.PricingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  govPriceRate: 'govPriceRate',
  startDate: 'startDate',
  isLastResort: 'isLastResort',
  vehiclePricingType: 'vehiclePricingType',
  pricePerKm: 'pricePerKm',
  flatFee: 'flatFee',
  nightRate: 'nightRate',
  sundayRate: 'sundayRate',
  waitingFee: 'waitingFee',
  noPatientFee: 'noPatientFee',
  incubatorExtra: 'incubatorExtra',
  airportStationPortExtra: 'airportStationPortExtra',
  pooling2DiscountRate: 'pooling2DiscountRate',
  pooling3DiscountRate: 'pooling3DiscountRate',
  tollOverride: 'tollOverride',
  useDistanceMap: 'useDistanceMap',
  kmIncludedInFlatFee: 'kmIncludedInFlatFee',
  agreementId: 'agreementId',
  zoneId: 'zoneId'
};

exports.Prisma.PtahConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabled: 'enabled',
  autoAccept: 'autoAccept',
  allowLateBooking: 'allowLateBooking',
  autoBook: 'autoBook',
  splitRoundtrip: 'splitRoundtrip',
  notifyDriverEvents: 'notifyDriverEvents',
  forcedFinessDem: 'forcedFinessDem',
  ptahId: 'ptahId',
  url: 'url',
  num: 'num',
  psw: 'psw',
  mod: 'mod',
  userId: 'userId'
};

exports.Prisma.PtahInfoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  RefTpt: 'RefTpt',
  RefTid: 'RefTid',
  RefMid: 'RefMid',
  RefTdr: 'RefTdr',
  pk: 'pk',
  deadline: 'deadline',
  davAt: 'davAt',
  finAt: 'finAt',
  configId: 'configId',
  missionId: 'missionId'
};

exports.Prisma.RavenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  thirdPartyId: 'thirdPartyId',
  type: 'type',
  to: 'to',
  content: 'content',
  phoneRavenStatus: 'phoneRavenStatus',
  price: 'price',
  queued: 'queued',
  sent: 'sent',
  blocked: 'blocked',
  delivered: 'delivered',
  read: 'read',
  clicked: 'clicked',
  canceled: 'canceled',
  failed: 'failed',
  changeRequestId: 'changeRequestId',
  missionId: 'missionId',
  invoiceId: 'invoiceId',
  orderId: 'orderId',
  appointmentId: 'appointmentId',
  manualInvoiceId: 'manualInvoiceId',
  amblerInvoiceId: 'amblerInvoiceId',
  mtReportId: 'mtReportId',
  transfusionEventId: 'transfusionEventId'
};

exports.Prisma.RobotConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabled: 'disabled',
  platform: 'platform',
  username: 'username',
  password: 'password',
  url: 'url',
  apiKey: 'apiKey'
};

exports.Prisma.ShortTripFeeTierScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  distance: 'distance',
  price: 'price',
  pricingId: 'pricingId'
};

exports.Prisma.SihMovementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pk: 'pk',
  movementId: 'movementId',
  startDate: 'startDate',
  medicalReponsibleFacilityFiness: 'medicalReponsibleFacilityFiness',
  careReponsibleFacilityFiness: 'careReponsibleFacilityFiness',
  ufLabel: 'ufLabel',
  ufCode: 'ufCode',
  isAwayOutbound: 'isAwayOutbound',
  isAwayInbound: 'isAwayInbound',
  visitId: 'visitId'
};

exports.Prisma.SihPatientScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pk: 'pk',
  ipp: 'ipp',
  sihId: 'sihId',
  lastname: 'lastname',
  firstname: 'firstname',
  birthname: 'birthname',
  gender: 'gender',
  birthdate: 'birthdate',
  deathdate: 'deathdate',
  phone: 'phone',
  email: 'email',
  addressRaw: 'addressRaw',
  addressDetails: 'addressDetails',
  isDead: 'isDead',
  nir: 'nir',
  socialSecurityRegion: 'socialSecurityRegion',
  healthInsuranceProvider: 'healthInsuranceProvider'
};

exports.Prisma.SihVisitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pk: 'pk',
  visitId: 'visitId',
  preadmitId: 'preadmitId',
  patientClass: 'patientClass',
  isAnonymous: 'isAnonymous',
  admissionFacilityFiness: 'admissionFacilityFiness',
  dischargedFacilityFiness: 'dischargedFacilityFiness',
  admissionDate: 'admissionDate',
  dischargeDate: 'dischargeDate',
  expectedAdmissionDate: 'expectedAdmissionDate',
  expectedDischargeDate: 'expectedDischargeDate',
  modeOfArrival: 'modeOfArrival',
  uf: 'uf',
  room: 'room',
  bed: 'bed',
  facilityFiness: 'facilityFiness',
  currentMovementId: 'currentMovementId',
  patientId: 'patientId'
};

exports.Prisma.TaskScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  status: 'status',
  scope: 'scope',
  pendingAt: 'pendingAt',
  terminatedAt: 'terminatedAt',
  details: 'details',
  missionId: 'missionId',
  passengerId: 'passengerId',
  assignedToId: 'assignedToId',
  invoiceId: 'invoiceId',
  manualInvoiceId: 'manualInvoiceId',
  amblerInvoiceId: 'amblerInvoiceId',
  bookingRequestId: 'bookingRequestId',
  mtReportId: 'mtReportId',
  dispatcherId: 'dispatcherId'
};

exports.Prisma.TdrContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mtId: 'mtId',
  salesForceId: 'salesForceId',
  type: 'type',
  ambulanceRate: 'ambulanceRate',
  tapFee: 'tapFee',
  tapPooling2Fee: 'tapPooling2Fee',
  tapPooling3Fee: 'tapPooling3Fee',
  vatRate: 'vatRate',
  frequency: 'frequency',
  paymentDelay: 'paymentDelay',
  delegatedPassengersToInvoice: 'delegatedPassengersToInvoice',
  excludeRequestedMt: 'excludeRequestedMt',
  startDate: 'startDate',
  endDate: 'endDate',
  revenueCategory: 'revenueCategory',
  clientCategory: 'clientCategory'
};

exports.Prisma.ThirdPartyPassengerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  acknowledgedAt: 'acknowledgedAt',
  discardedAt: 'discardedAt'
};

exports.Prisma.TrafficControlMetricScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  missionsToDispatch: 'missionsToDispatch',
  dailyBookedPassengers: 'dailyBookedPassengers',
  dailyScheduledPassengers: 'dailyScheduledPassengers',
  weeklyBookedPassengers: 'weeklyBookedPassengers'
};

exports.Prisma.TransportReasonCustomizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  groupId: 'groupId',
  label: 'label',
  index: 'index',
  reason: 'reason'
};

exports.Prisma.TransportReasonCustomizationGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mfuId: 'mfuId',
  label: 'label',
  index: 'index'
};

exports.Prisma.TripScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  missionId: 'missionId',
  assignedMtId: 'assignedMtId',
  intermediateMtId: 'intermediateMtId',
  assignedVehicle: 'assignedVehicle',
  departureTime: 'departureTime',
  validPassengerCount: 'validPassengerCount'
};

exports.Prisma.TripPriceOverrideScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  toll: 'toll',
  km: 'km',
  timeSlot: 'timeSlot',
  isWaitingFeeApplied: 'isWaitingFeeApplied',
  poolingDiscountRate: 'poolingDiscountRate',
  tripBlockId: 'tripBlockId'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  lastLoginAt: 'lastLoginAt',
  auth0Id: 'auth0Id',
  keycloakId: 'keycloakId',
  name: 'name',
  email: 'email',
  phone: 'phone',
  role: 'role',
  isEmailConfirmed: 'isEmailConfirmed',
  confirmationSlug: 'confirmationSlug',
  avatarUrl: 'avatarUrl',
  allowBrEmail: 'allowBrEmail'
};

exports.Prisma.UserMfuAclScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  invitedEmail: 'invitedEmail',
  mfuId: 'mfuId',
  canOrder: 'canOrder',
  canList: 'canList',
  preferredMfdId: 'preferredMfdId',
  missionBookedEmailRecipients: 'missionBookedEmailRecipients',
  missionToDispatchEmailRecipients: 'missionToDispatchEmailRecipients',
  missionRedispatchedEmailRecipients: 'missionRedispatchedEmailRecipients',
  missionTptrNotFoundEmailRecipients: 'missionTptrNotFoundEmailRecipients'
};

exports.Prisma.UserMfuAclSignatureRightScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userMfuAclId: 'userMfuAclId',
  doctorId: 'doctorId',
  scope: 'scope'
};

exports.Prisma.VehicleCustomizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  vehicleType: 'vehicleType',
  mfuSpecificNeedsId: 'mfuSpecificNeedsId',
  mfuPatientConditionsId: 'mfuPatientConditionsId'
};

exports.Prisma.VehicleCustomizationFieldScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  state: 'state',
  label: 'label',
  vehicleCustomizationId: 'vehicleCustomizationId'
};

exports.Prisma.ZoneScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  z: 'z',
  polygon: 'polygon',
  mapId: 'mapId'
};

exports.Prisma.ZoneMapScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mid: 'mid'
};

exports.Prisma.AmblerInvoiceScalarFieldEnum = {
  id: 'id',
  primaryKey: 'primaryKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  initialStatus: 'initialStatus',
  type: 'type',
  sequenceNumber: 'sequenceNumber',
  wasAnnouncedAsSepa: 'wasAnnouncedAsSepa',
  tdrContractId: 'tdrContractId',
  a4cContractId: 'a4cContractId',
  a4hlContractId: 'a4hlContractId',
  a4hsContractId: 'a4hsContractId',
  aldContractId: 'aldContractId',
  prestationId: 'prestationId',
  price: 'price',
  priceWithVat: 'priceWithVat',
  vat: 'vat',
  startDate: 'startDate',
  endDate: 'endDate',
  dueAt: 'dueAt',
  finalizedAt: 'finalizedAt',
  assignedInvoicerId: 'assignedInvoicerId'
};

exports.Prisma.BookingRequestEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  otherFields: 'otherFields',
  byId: 'byId',
  bookingRequestId: 'bookingRequestId'
};

exports.Prisma.BrTcNoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  content: 'content',
  brId: 'brId',
  byId: 'byId'
};

exports.Prisma.InseeFlatFeeTypeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  inseeCode: 'inseeCode',
  ambulanceFlatFeeType: 'ambulanceFlatFeeType',
  tapFlatFeeType: 'tapFlatFeeType',
  flatFeeTypeZone: 'flatFeeTypeZone'
};

exports.Prisma.MedicalTransporterReviewRequestedChangeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  resolved: 'resolved',
  old: 'old',
  new: 'new',
  comment: 'comment',
  reviewId: 'reviewId'
};

exports.Prisma.MedicalTransporterReviewRequestedChangeEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  comment: 'comment',
  userId: 'userId',
  requestedChangeId: 'requestedChangeId'
};

exports.Prisma.PostApprovalInvoiceModificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  type: 'type',
  metadata: 'metadata',
  invoiceId: 'invoiceId',
  passengerId: 'passengerId'
};

exports.Prisma.WeeklyMetricScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  index: 'index',
  trafficControlMetricId: 'trafficControlMetricId',
  week: 'week',
  year: 'year',
  bookedPassengers: 'bookedPassengers'
};

exports.Prisma.AmblerInvoiceEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  byId: 'byId',
  amblerInvoiceId: 'amblerInvoiceId'
};

exports.Prisma.AmblerInvoicingModificationRequestScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  type: 'type',
  metadata: 'metadata',
  amblerInvoiceId: 'amblerInvoiceId',
  passengerId: 'passengerId'
};

exports.Prisma.AmblerCreditNoteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  amblerInvoiceId: 'amblerInvoiceId',
  sequenceNumber: 'sequenceNumber',
  primaryKey: 'primaryKey'
};

exports.Prisma.SuperSizedPlaceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  metersToAdd: 'metersToAdd',
  placeId: 'placeId',
  distanceMapId: 'distanceMapId'
};

exports.Prisma.PassengerCancelationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  comment: 'comment',
  byId: 'byId',
  passengerId: 'passengerId'
};

exports.Prisma.A4hlContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mfId: 'mfId',
  salesForceId: 'salesForceId',
  revShare5: 'revShare5',
  revShare6: 'revShare6',
  revShare7: 'revShare7',
  revShare8: 'revShare8',
  revShare9: 'revShare9',
  revShare10: 'revShare10',
  revShare11: 'revShare11',
  revShare12: 'revShare12',
  revShare13: 'revShare13',
  revShare14: 'revShare14',
  revShare15: 'revShare15',
  additionalRevShareBeyond15: 'additionalRevShareBeyond15',
  vatRate: 'vatRate',
  rmg: 'rmg',
  rmgRate: 'rmgRate',
  revShareEnabled: 'revShareEnabled',
  frequency: 'frequency',
  paymentDelay: 'paymentDelay',
  startDate: 'startDate',
  endDate: 'endDate',
  revenueCategory: 'revenueCategory',
  clientCategory: 'clientCategory'
};

exports.Prisma.SihAppointmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  pk: 'pk',
  appointmentId: 'appointmentId',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
  reasonEnum: 'reasonEnum',
  reasonText: 'reasonText',
  locationRaw: 'locationRaw',
  lastMsgEventDate: 'lastMsgEventDate',
  patientId: 'patientId'
};

exports.Prisma.A4hsContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mfId: 'mfId',
  salesForceId: 'salesForceId',
  vatRate: 'vatRate',
  priceForSoftware: 'priceForSoftware',
  priceForTrafficControl: 'priceForTrafficControl',
  fichcompEnabled: 'fichcompEnabled',
  ePmtEnabled: 'ePmtEnabled',
  frequency: 'frequency',
  paymentDelay: 'paymentDelay',
  startDate: 'startDate',
  endDate: 'endDate',
  revenueCategory: 'revenueCategory',
  clientCategory: 'clientCategory'
};

exports.Prisma.AldContractScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mfId: 'mfId',
  salesForceId: 'salesForceId',
  rmg: 'rmg',
  fixedFees: 'fixedFees',
  tripFees: 'tripFees',
  vatRate: 'vatRate',
  frequency: 'frequency',
  paymentDelay: 'paymentDelay',
  startDate: 'startDate',
  endDate: 'endDate',
  excludeArt80Passengers: 'excludeArt80Passengers',
  revenueCategory: 'revenueCategory',
  clientCategory: 'clientCategory'
};

exports.Prisma.BundlePayerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payer: 'payer',
  bundleId: 'bundleId'
};

exports.Prisma.BundleTransportReasonScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  reason: 'reason',
  bundleId: 'bundleId'
};

exports.Prisma.BundleTimeRangeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  startDay: 'startDay',
  startHour: 'startHour',
  endDay: 'endDay',
  endHour: 'endHour',
  holidays: 'holidays',
  bundleId: 'bundleId'
};

exports.Prisma.PrestationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mfId: 'mfId',
  mtId: 'mtId',
  salesForceId: 'salesForceId',
  vatRate: 'vatRate',
  price: 'price',
  paymentDelay: 'paymentDelay',
  invoicingDate: 'invoicingDate',
  type: 'type',
  label: 'label',
  revenueCategory: 'revenueCategory',
  clientCategory: 'clientCategory'
};

exports.Prisma.AppointmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  startDate: 'startDate',
  endDate: 'endDate',
  reasonEnum: 'reasonEnum',
  reasonText: 'reasonText',
  locationRaw: 'locationRaw',
  patientId: 'patientId',
  mfuId: 'mfuId',
  sihAppointmentId: 'sihAppointmentId'
};

exports.Prisma.OptimTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  optimizationRequestId: 'optimizationRequestId',
  status: 'status',
  rearrangeComment: 'rearrangeComment',
  startDate: 'startDate',
  mfuId: 'mfuId',
  mfdId: 'mfdId',
  patient1Id: 'patient1Id',
  patient2Id: 'patient2Id',
  mt1Id: 'mt1Id',
  mt2Id: 'mt2Id',
  patient1PlaceId: 'patient1PlaceId',
  patient2PlaceId: 'patient2PlaceId',
  mfPlaceId: 'mfPlaceId',
  mt1Vehicle: 'mt1Vehicle',
  mt2Vehicle: 'mt2Vehicle'
};

exports.Prisma.OptimTemplateDayScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  weekday: 'weekday',
  outboundArrivalTimeOfDay: 'outboundArrivalTimeOfDay',
  outboundPatient1DepartureTimeOfDay: 'outboundPatient1DepartureTimeOfDay',
  outboundPatient2DepartureTimeOfDay: 'outboundPatient2DepartureTimeOfDay',
  outboundMt: 'outboundMt',
  outboundDuration: 'outboundDuration',
  inboundDuration: 'inboundDuration',
  inboundDepartureTimeOfDay: 'inboundDepartureTimeOfDay',
  inboundPatient1ArrivalTimeOfDay: 'inboundPatient1ArrivalTimeOfDay',
  inboundPatient2ArrivalTimeOfDay: 'inboundPatient2ArrivalTimeOfDay',
  inboundMt: 'inboundMt',
  outboundDistance: 'outboundDistance',
  inboundDistance: 'inboundDistance',
  outboundPatient1CostBeforeOptim: 'outboundPatient1CostBeforeOptim',
  outboundPatient2CostBeforeOptim: 'outboundPatient2CostBeforeOptim',
  inboundPatient1CostBeforeOptim: 'inboundPatient1CostBeforeOptim',
  inboundPatient2CostBeforeOptim: 'inboundPatient2CostBeforeOptim',
  outboundMt1TurnoverAfterOptim: 'outboundMt1TurnoverAfterOptim',
  outboundMt2TurnoverAfterOptim: 'outboundMt2TurnoverAfterOptim',
  inboundMt1TurnoverAfterOptim: 'inboundMt1TurnoverAfterOptim',
  inboundMt2TurnoverAfterOptim: 'inboundMt2TurnoverAfterOptim',
  outboundPatient1CostWithMt1: 'outboundPatient1CostWithMt1',
  outboundPatient1CostWithMt2: 'outboundPatient1CostWithMt2',
  outboundPatient2CostWithMt1: 'outboundPatient2CostWithMt1',
  outboundPatient2CostWithMt2: 'outboundPatient2CostWithMt2',
  inboundPatient1CostWithMt1: 'inboundPatient1CostWithMt1',
  inboundPatient1CostWithMt2: 'inboundPatient1CostWithMt2',
  inboundPatient2CostWithMt1: 'inboundPatient2CostWithMt1',
  inboundPatient2CostWithMt2: 'inboundPatient2CostWithMt2',
  outboundPatient1DistanceBeforeOptim: 'outboundPatient1DistanceBeforeOptim',
  outboundPatient2DistanceBeforeOptim: 'outboundPatient2DistanceBeforeOptim',
  inboundPatient1DistanceBeforeOptim: 'inboundPatient1DistanceBeforeOptim',
  inboundPatient2DistanceBeforeOptim: 'inboundPatient2DistanceBeforeOptim',
  outboundPatient1Detour: 'outboundPatient1Detour',
  inboundPatient1Detour: 'inboundPatient1Detour',
  outboundPatient1WaitingTime: 'outboundPatient1WaitingTime',
  outboundPatient2WaitingTime: 'outboundPatient2WaitingTime',
  inboundPatient1WaitingTime: 'inboundPatient1WaitingTime',
  inboundPatient2WaitingTime: 'inboundPatient2WaitingTime',
  originalOutboundMt: 'originalOutboundMt',
  originalInboundMt: 'originalInboundMt',
  templateId: 'templateId'
};

exports.Prisma.PatientConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  patientId: 'patientId',
  needAutoOrder: 'needAutoOrder',
  needPooling: 'needPooling',
  defaultMtId: 'defaultMtId',
  defaultTap: 'defaultTap',
  vehicle: 'vehicle',
  transportReason: 'transportReason',
  reason: 'reason',
  specificNeeds: 'specificNeeds',
  patientCondition: 'patientCondition',
  isAccompanied: 'isAccompanied',
  details: 'details',
  mfuNotes: 'mfuNotes',
  originId: 'originId',
  originMfdId: 'originMfdId',
  destinationId: 'destinationId',
  destinationMfdId: 'destinationMfdId'
};

exports.Prisma.ManualInvoiceDocumentErrorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  field: 'field',
  expectedValue: 'expectedValue',
  actualValue: 'actualValue',
  ignoreError: 'ignoreError',
  manualInvoiceId: 'manualInvoiceId'
};

exports.Prisma.PreferredMtCustomizationRuleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  allowedDepartureMargin: 'allowedDepartureMargin',
  allowedArrivalMargin: 'allowedArrivalMargin',
  customizationId: 'customizationId'
};

exports.Prisma.PreferredMtCustomizationRulePayerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  payer: 'payer',
  ruleId: 'ruleId'
};

exports.Prisma.SpeedCallApiKeyMappingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastloginAt: 'lastloginAt',
  v1: 'v1',
  speedtrackCarrierApiKey: 'speedtrackCarrierApiKey',
  v2CarrierId: 'v2CarrierId',
  mtId: 'mtId',
  startDate: 'startDate'
};

exports.Prisma.SpeedCallRelationKeyMappingScalarFieldEnum = {
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  relationKey: 'relationKey',
  speedCallMissionNumber: 'speedCallMissionNumber'
};

exports.Prisma.AlternativeMedicalFacilityNameScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  mfId: 'mfId'
};

exports.Prisma.UserPermissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  validUntil: 'validUntil',
  userId: 'userId',
  grantedById: 'grantedById'
};

exports.Prisma.ViaMichelinDistanceMapEntryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  meters: 'meters',
  toll: 'toll'
};

exports.Prisma.TransfusionEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subject: 'subject',
  type: 'type',
  relatedId: 'relatedId',
  carrierId: 'carrierId'
};

exports.Prisma.SpeedCallMedicalTransporterScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  transfusionType: 'transfusionType',
  transfusionStep: 'transfusionStep',
  tranfusedAt: 'tranfusedAt',
  transfusionBatch: 'transfusionBatch',
  name: 'name',
  phone: 'phone',
  addressRaw: 'addressRaw',
  zipcode: 'zipcode',
  siret: 'siret',
  v2Id: 'v2Id',
  v1Id: 'v1Id',
  v1ActorId: 'v1ActorId',
  taxiCount: 'taxiCount',
  vslCount: 'vslCount',
  ambulanceCount: 'ambulanceCount',
  tpmrCount: 'tpmrCount',
  bariatricCount: 'bariatricCount',
  medicalCount: 'medicalCount',
  paramedicalCount: 'paramedicalCount',
  adminEmails: 'adminEmails',
  viewerEmails: 'viewerEmails',
  mtId: 'mtId'
};

exports.Prisma.SyncUserConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  label: 'label',
  bucketName: 'bucketName',
  mode: 'mode'
};

exports.Prisma.HprimConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  label: 'label',
  bucketName: 'bucketName',
  fileDir: 'fileDir',
  startDate: 'startDate',
  fromCode: 'fromCode',
  fromLabel: 'fromLabel',
  toCode: 'toCode',
  toLabel: 'toLabel'
};

exports.Prisma.MtSectorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  transportMode: 'transportMode',
  disabled: 'disabled',
  isWhiteZone: 'isWhiteZone',
  refWeight: 'refWeight',
  sectorId: 'sectorId',
  mtId: 'mtId'
};

exports.Prisma.SectorScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  label: 'label',
  inseeCode: 'inseeCode',
  numberOfResidents: 'numberOfResidents',
  zipcodes: 'zipcodes',
  neighbourInseeCodes: 'neighbourInseeCodes',
  lat: 'lat',
  lng: 'lng',
  townshipId: 'townshipId'
};

exports.Prisma.SectorGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  code: 'code',
  label: 'label'
};

exports.Prisma.FleetConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  hasRegulation: 'hasRegulation',
  departureTimeMin: 'departureTimeMin',
  departureTimeMax: 'departureTimeMax',
  regulationOpeningTime: 'regulationOpeningTime',
  regulationClosingTime: 'regulationClosingTime',
  protectionThreshold: 'protectionThreshold',
  protectionDuration: 'protectionDuration',
  workingDays: 'workingDays',
  mtId: 'mtId'
};

exports.Prisma.FleetDriverScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  firstname: 'firstname',
  lastname: 'lastname',
  identifier: 'identifier',
  phoneNumber: 'phoneNumber',
  primaryKey: 'primaryKey',
  configId: 'configId',
  aclId: 'aclId'
};

exports.Prisma.FleetMissionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sentAt: 'sentAt',
  acknowledgedAt: 'acknowledgedAt',
  currentLegIndex: 'currentLegIndex',
  vehicleId: 'vehicleId',
  configId: 'configId',
  tripId: 'tripId'
};

exports.Prisma.FleetVehicleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  type: 'type',
  identifier: 'identifier',
  phoneNumber: 'phoneNumber',
  primaryKey: 'primaryKey',
  configId: 'configId'
};

exports.Prisma.TownshipScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name'
};

exports.Prisma.PreconfiguredTdrScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  label: 'label',
  archivedAt: 'archivedAt'
};

exports.Prisma.StretcherModCustomizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  patientBirthdateState: 'patientBirthdateState',
  patientBirthdateLabel: 'patientBirthdateLabel',
  patientBirthnameState: 'patientBirthnameState',
  patientBirthnameLabel: 'patientBirthnameLabel',
  patientIppState: 'patientIppState',
  patientIppLabel: 'patientIppLabel',
  patientVisitIdState: 'patientVisitIdState',
  patientVisitIdLabel: 'patientVisitIdLabel',
  patientRoomState: 'patientRoomState',
  patientRoomLabel: 'patientRoomLabel',
  mfId: 'mfId'
};

exports.Prisma.StretcherModVehicleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  label: 'label',
  isUsed: 'isUsed',
  customizationId: 'customizationId'
};

exports.Prisma.StretcherModPatientSpecificNeedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  label: 'label',
  isUsed: 'isUsed',
  vehicleId: 'vehicleId'
};

exports.Prisma.StretcherModPatientConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  label: 'label',
  isUsed: 'isUsed',
  vehicleId: 'vehicleId'
};

exports.Prisma.StretcherModTransportReasonGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  label: 'label',
  position: 'position',
  customizationId: 'customizationId'
};

exports.Prisma.StretcherModTransportReasonScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  type: 'type',
  label: 'label',
  position: 'position',
  togglePrecision: 'togglePrecision',
  groupId: 'groupId'
};

exports.Prisma.StretcherModRouteConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  defaultTravelDuration: 'defaultTravelDuration',
  defaultDistance: 'defaultDistance',
  defaultPickUpDuration: 'defaultPickUpDuration',
  defaultDropOffDuration: 'defaultDropOffDuration',
  mfId: 'mfId'
};

exports.Prisma.StretcherModRouteScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  configId: 'configId',
  originMfdId: 'originMfdId',
  destinationMfdId: 'destinationMfdId',
  duration: 'duration',
  distance: 'distance'
};

exports.Prisma.StretcherModOrderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  confirmedAt: 'confirmedAt',
  mfuId: 'mfuId',
  ownerId: 'ownerId',
  patientId: 'patientId',
  patientVisitId: 'patientVisitId',
  details: 'details'
};

exports.Prisma.StretcherModOrderStepScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orderId: 'orderId',
  position: 'position',
  mfdId: 'mfdId',
  additionalInformation: 'additionalInformation',
  timeReference: 'timeReference',
  date: 'date',
  vehicleId: 'vehicleId',
  vehicleLabel: 'vehicleLabel',
  transportReasonId: 'transportReasonId',
  transportReasonLabel: 'transportReasonLabel',
  reasonPrecision: 'reasonPrecision'
};

exports.Prisma.StretcherModOrderStepSpecificNeedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  stepId: 'stepId',
  specificNeedId: 'specificNeedId',
  label: 'label'
};

exports.Prisma.StretcherModOrderStepPatientConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  stepId: 'stepId',
  patientConditionId: 'patientConditionId',
  label: 'label'
};

exports.Prisma.StretcherModSegmentSpecificNeedScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  segmentId: 'segmentId',
  specificNeedId: 'specificNeedId',
  label: 'label'
};

exports.Prisma.StretcherModSegmentPatientConditionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  segmentId: 'segmentId',
  patientConditionId: 'patientConditionId',
  label: 'label'
};

exports.Prisma.StretcherModSegmentDriverScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  segmentId: 'segmentId',
  driverId: 'driverId'
};

exports.Prisma.StretcherModUnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  name: 'name',
  phoneNumbers: 'phoneNumbers',
  mfId: 'mfId'
};

exports.Prisma.StretcherModUnitAclScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role',
  userId: 'userId',
  invitedEmail: 'invitedEmail',
  unitId: 'unitId'
};

exports.Prisma.StretcherModDriverScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  disabledAt: 'disabledAt',
  firstname: 'firstname',
  lastname: 'lastname',
  identifier: 'identifier',
  phoneNumber: 'phoneNumber',
  primaryKey: 'primaryKey',
  unitId: 'unitId',
  aclId: 'aclId'
};

exports.Prisma.StretcherModSegmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orderId: 'orderId',
  journeyId: 'journeyId',
  position: 'position',
  mfuId: 'mfuId',
  ownerId: 'ownerId',
  unitId: 'unitId',
  status: 'status',
  patientId: 'patientId',
  patientVisitId: 'patientVisitId',
  vehicleId: 'vehicleId',
  vehicleLabel: 'vehicleLabel',
  transportReasonId: 'transportReasonId',
  transportReasonLabel: 'transportReasonLabel',
  reasonPrecision: 'reasonPrecision',
  details: 'details',
  originMfdId: 'originMfdId',
  originAdditionalInformation: 'originAdditionalInformation',
  destinationMfdId: 'destinationMfdId',
  destinationAdditionalInformation: 'destinationAdditionalInformation',
  initialTimeReference: 'initialTimeReference',
  initialDepartureTime: 'initialDepartureTime',
  initialArrivalTime: 'initialArrivalTime',
  timeReference: 'timeReference',
  departureTime: 'departureTime',
  arrivalTime: 'arrivalTime',
  timezone: 'timezone',
  duration: 'duration',
  distance: 'distance',
  sentAt: 'sentAt',
  acknowledgedAt: 'acknowledgedAt',
  currentLegIndex: 'currentLegIndex'
};

exports.Prisma.StretcherModSegmentEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  type: 'type',
  otherFields: 'otherFields',
  byId: 'byId',
  segmentId: 'segmentId'
};

exports.Prisma.StretcherModDriverEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  firedAt: 'firedAt',
  driverId: 'driverId',
  segmentId: 'segmentId'
};

exports.Prisma.AuthSessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  secretHash: 'secretHash',
  issuer: 'issuer',
  subject: 'subject',
  expiresAt: 'expiresAt',
  absoluteExpiresAt: 'absoluteExpiresAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.PaymentStatus = exports.$Enums.PaymentStatus = {
  NOT_PAID: 'NOT_PAID',
  DI_HPTLA: 'DI_HPTLA',
  DI_HPTLA_HPTLB: 'DI_HPTLA_HPTLB',
  DI_HPTLA_PTNT: 'DI_HPTLA_PTNT',
  DI_HPTLB: 'DI_HPTLB',
  DI_AMBLER: 'DI_AMBLER',
  DI_PTNT: 'DI_PTNT',
  HPTLA: 'HPTLA',
  HPTLA_HPTLB: 'HPTLA_HPTLB',
  HPTLA_PTNT: 'HPTLA_PTNT',
  HPTLB: 'HPTLB',
  AMBLER: 'AMBLER',
  PTNT: 'PTNT',
  GOV: 'GOV'
};

exports.BillingFrequency = exports.$Enums.BillingFrequency = {
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  SEMESTERLY: 'SEMESTERLY',
  YEARLY: 'YEARLY',
  UNIQUE: 'UNIQUE'
};

exports.DelegatedPassengersToInvoice = exports.$Enums.DelegatedPassengersToInvoice = {
  NONE: 'NONE',
  WITHOUT_CONTRACT: 'WITHOUT_CONTRACT'
};

exports.RevenueCategory = exports.$Enums.RevenueCategory = {
  SOFTWARE_HC: 'SOFTWARE_HC',
  SOFTWARE_ALD: 'SOFTWARE_ALD',
  SOFTWARE_AND_REGULATION_HC: 'SOFTWARE_AND_REGULATION_HC',
  SOFTWARE_AND_REGULATION_ALD: 'SOFTWARE_AND_REGULATION_ALD',
  SOFTWARE_AND_INVOICING_HC: 'SOFTWARE_AND_INVOICING_HC',
  SOFTWARE_AND_REGULATION_AND_INVOICING_HC: 'SOFTWARE_AND_REGULATION_AND_INVOICING_HC',
  FAS: 'FAS',
  OTHER_RECURRING_MF: 'OTHER_RECURRING_MF',
  RECURRING_MT: 'RECURRING_MT',
  GEOLOCATION_MT: 'GEOLOCATION_MT',
  RECURRING_TELEPHONY_AND_IT: 'RECURRING_TELEPHONY_AND_IT',
  OTHER_REVENUE: 'OTHER_REVENUE'
};

exports.ClientCategory = exports.$Enums.ClientCategory = {
  EMEIS: 'EMEIS',
  CLARIANE: 'CLARIANE',
  ELSAN: 'ELSAN',
  MF_NA: 'MF_NA',
  CH_GHT_CENTRALES_HORS_NA: 'CH_GHT_CENTRALES_HORS_NA',
  OTHER_MF: 'OTHER_MF',
  OTHER_ALD: 'OTHER_ALD',
  GROUPEMENT_MT: 'GROUPEMENT_MT',
  TDR: 'TDR',
  MT_NA: 'MT_NA',
  OTHER_MT: 'OTHER_MT',
  RECURRING_PHONE_AND_IT: 'RECURRING_PHONE_AND_IT'
};

exports.BookingRequestStatus = exports.$Enums.BookingRequestStatus = {
  WAITING: 'WAITING',
  PENDING: 'PENDING',
  PROTECTED: 'PROTECTED',
  COUNTER_OFFER_PENDING: 'COUNTER_OFFER_PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
  DUPLICATED: 'DUPLICATED',
  HPTL_ACCEPTED: 'HPTL_ACCEPTED',
  TC_ACCEPTED: 'TC_ACCEPTED',
  TPTR_ACCEPTED: 'TPTR_ACCEPTED',
  AUTO_ACCEPTED: 'AUTO_ACCEPTED',
  HPTL_REFUSED: 'HPTL_REFUSED',
  TC_REFUSED: 'TC_REFUSED',
  TPTR_REFUSED: 'TPTR_REFUSED',
  HOLIDAY_REFUSED: 'HOLIDAY_REFUSED',
  BLACKLISTED: 'BLACKLISTED',
  NOT_SENT: 'NOT_SENT'
};

exports.DispatchAlgorithm = exports.$Enums.DispatchAlgorithm = {
  WEIGHTED_RANDOM: 'WEIGHTED_RANDOM',
  CLOSEST_HOME: 'CLOSEST_HOME',
  CHEAPEST_CLOSEST: 'CHEAPEST_CLOSEST',
  RANDOM: 'RANDOM'
};

exports.ThirdPartyPlatform = exports.$Enums.ThirdPartyPlatform = {
  ELISA: 'ELISA',
  GTWEB: 'GTWEB',
  SAPHYR: 'SAPHYR'
};

exports.BundleType = exports.$Enums.BundleType = {
  VARIABLE_TIME: 'VARIABLE_TIME',
  FIXED_TIME: 'FIXED_TIME'
};

exports.Vehicle = exports.$Enums.Vehicle = {
  VSL: 'VSL',
  TAXI: 'TAXI',
  AMBULANCE: 'AMBULANCE',
  TPMR: 'TPMR',
  BARIATRIC: 'BARIATRIC',
  PARAMEDICAL: 'PARAMEDICAL',
  MEDICAL: 'MEDICAL',
  TPS: 'TPS'
};

exports.MtSelectionType = exports.$Enums.MtSelectionType = {
  LIST: 'LIST',
  SECTOR: 'SECTOR',
  COUNTER_OFFER: 'COUNTER_OFFER'
};

exports.BundleRulePrecision = exports.$Enums.BundleRulePrecision = {
  VILLE: 'VILLE',
  CANTON: 'CANTON',
  CANTONS_LIMITROPHES: 'CANTONS_LIMITROPHES',
  DEPARTEMENT: 'DEPARTEMENT',
  VILLES_LIMITROPHES: 'VILLES_LIMITROPHES'
};

exports.BundleRuleSource = exports.$Enums.BundleRuleSource = {
  PATIENT: 'PATIENT',
  MF: 'MF',
  DEPARTURE: 'DEPARTURE',
  ARRIVAL: 'ARRIVAL'
};

exports.BundleRuleType = exports.$Enums.BundleRuleType = {
  CONTRACTOR: 'CONTRACTOR',
  BACKUP: 'BACKUP'
};

exports.CancelOrderStatus = exports.$Enums.CancelOrderStatus = {
  CREATED: 'CREATED',
  CONFIRMED: 'CONFIRMED',
  ABORTED: 'ABORTED'
};

exports.ChangeRequestStatus = exports.$Enums.ChangeRequestStatus = {
  PENDING: 'PENDING',
  ACCEPTED: 'ACCEPTED',
  TPTR_ACCEPTED: 'TPTR_ACCEPTED',
  TC_ACCEPTED: 'TC_ACCEPTED',
  HPTL_ACCEPTED: 'HPTL_ACCEPTED',
  AUTO_ACCEPTED: 'AUTO_ACCEPTED',
  DECLINED: 'DECLINED',
  TPTR_REFUSED: 'TPTR_REFUSED',
  TC_REFUSED: 'TC_REFUSED',
  HPTL_REFUSED: 'HPTL_REFUSED',
  EXPIRED: 'EXPIRED'
};

exports.Payer = exports.$Enums.Payer = {
  GOV: 'GOV',
  PTNT: 'PTNT',
  HPTL_A: 'HPTL_A',
  HPTL_A_NOTART80: 'HPTL_A_NOTART80',
  HPTL_B: 'HPTL_B',
  TPS_A: 'TPS_A'
};

exports.FieldState = exports.$Enums.FieldState = {
  USED: 'USED',
  USED_AND_REQUIRED: 'USED_AND_REQUIRED',
  UNUSED: 'UNUSED'
};

exports.Product = exports.$Enums.Product = {
  APP: 'APP',
  BO: 'BO'
};

exports.DeviceType = exports.$Enums.DeviceType = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  WEB: 'WEB'
};

exports.DeviceState = exports.$Enums.DeviceState = {
  INITIAL: 'INITIAL',
  GRANTED: 'GRANTED',
  DENIED: 'DENIED',
  UNSUPPORTED: 'UNSUPPORTED',
  LOGGED_OUT: 'LOGGED_OUT'
};

exports.DriverEventType = exports.$Enums.DriverEventType = {
  START: 'START',
  AT_ORIGIN: 'AT_ORIGIN',
  PICK_UP: 'PICK_UP',
  AT_DESTINATION: 'AT_DESTINATION',
  DROP_OFF: 'DROP_OFF',
  END: 'END'
};

exports.ExportRequestStatus = exports.$Enums.ExportRequestStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  DONE: 'DONE',
  ERRORED: 'ERRORED'
};

exports.ExportRequestKind = exports.$Enums.ExportRequestKind = {
  PASSENGERS_XLSX: 'PASSENGERS_XLSX',
  PASSENGERS_ANON_XLSX: 'PASSENGERS_ANON_XLSX',
  PASSENGERS_CSV: 'PASSENGERS_CSV',
  PASSENGERS_ANON_CSV: 'PASSENGERS_ANON_CSV',
  FICHCOMP_MCO_TXT: 'FICHCOMP_MCO_TXT',
  FICHCOMP_SSRPSY_TXT: 'FICHCOMP_SSRPSY_TXT',
  FICHCOMP_SSR_TXT: 'FICHCOMP_SSR_TXT',
  FICHCOMP_PSY_TXT: 'FICHCOMP_PSY_TXT',
  ATTENDANCE_SHEET: 'ATTENDANCE_SHEET',
  POOLING_AND_CIRCUIT_XLSX: 'POOLING_AND_CIRCUIT_XLSX'
};

exports.ProductContext = exports.$Enums.ProductContext = {
  A4H: 'A4H',
  A4T: 'A4T',
  BO: 'BO',
  A4D: 'A4D'
};

exports.FlatFeeType = exports.$Enums.FlatFeeType = {
  DEPARTEMENTAL: 'DEPARTEMENTAL',
  AGGLOMERATION: 'AGGLOMERATION',
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  PRISE_EN_CHARGE: 'PRISE_EN_CHARGE',
  GOV_PATIENT_SUPPORT_AND_SLOW_WALKING: 'GOV_PATIENT_SUPPORT_AND_SLOW_WALKING',
  GOV_BASRHIN_AGGLOMERATION: 'GOV_BASRHIN_AGGLOMERATION',
  GOV_BASRHIN_OUTSIDE: 'GOV_BASRHIN_OUTSIDE'
};

exports.InvoiceStatus = exports.$Enums.InvoiceStatus = {
  WAIT_TC_RELAUNCH: 'WAIT_TC_RELAUNCH',
  WAIT_TPTR_APPROVAL: 'WAIT_TPTR_APPROVAL',
  WAIT_HPTL_APPROVAL: 'WAIT_HPTL_APPROVAL',
  WAIT_PASSENGERS_CONFIRMATION: 'WAIT_PASSENGERS_CONFIRMATION',
  DROPPED: 'DROPPED',
  EDIT_DROPPED: 'EDIT_DROPPED',
  EDIT_DROPPED_AMBLER: 'EDIT_DROPPED_AMBLER',
  APPROVED: 'APPROVED',
  REPLACED: 'REPLACED',
  CANCELED: 'CANCELED'
};

exports.InvoiceEventStatus = exports.$Enums.InvoiceEventStatus = {
  CREATE: 'CREATE',
  TC_CREATE: 'TC_CREATE',
  EDIT: 'EDIT',
  REPLACE: 'REPLACE',
  TPTR_APPROVE: 'TPTR_APPROVE',
  AUTO_TPTR_APPROVE: 'AUTO_TPTR_APPROVE',
  AUTO_TPTR_REFUSE: 'AUTO_TPTR_REFUSE',
  TC_TPTR_REFUSE: 'TC_TPTR_REFUSE',
  TC_TPTR_APPROVE: 'TC_TPTR_APPROVE',
  AUTO_HPTL_REFUSE: 'AUTO_HPTL_REFUSE',
  TC_HPTL_REFUSE: 'TC_HPTL_REFUSE',
  WAIT_TC_RELAUNCH: 'WAIT_TC_RELAUNCH',
  WAIT_TPTR_APPROVAL: 'WAIT_TPTR_APPROVAL',
  WAIT_HPTL_APPROVAL: 'WAIT_HPTL_APPROVAL',
  WAIT_PASSENGERS_CONFIRMATION: 'WAIT_PASSENGERS_CONFIRMATION',
  DROPPED: 'DROPPED',
  EDIT_DROPPED: 'EDIT_DROPPED',
  EDIT_DROPPED_AMBLER: 'EDIT_DROPPED_AMBLER',
  APPROVED: 'APPROVED',
  REPLACED: 'REPLACED',
  CANCELED: 'CANCELED',
  TC_ACCEPT_POST_APPROVAL_MODIFICATION: 'TC_ACCEPT_POST_APPROVAL_MODIFICATION',
  TC_DECLINE_POST_APPROVAL_MODIFICATION: 'TC_DECLINE_POST_APPROVAL_MODIFICATION'
};

exports.EventStatusType = exports.$Enums.EventStatusType = {
  REGULAR: 'REGULAR',
  FLASH: 'FLASH',
  LOG: 'LOG'
};

exports.ManualInvoiceStatus = exports.$Enums.ManualInvoiceStatus = {
  CREATED: 'CREATED',
  WAIT_AUTO_APPROVAL: 'WAIT_AUTO_APPROVAL',
  WAIT_AMBLER_APPROVAL: 'WAIT_AMBLER_APPROVAL',
  WAIT_HPTL_APPROVAL: 'WAIT_HPTL_APPROVAL',
  APPROVED: 'APPROVED',
  REFUSED: 'REFUSED',
  DROPPED: 'DROPPED'
};

exports.RefuseMtManualInvoiceReason = exports.$Enums.RefuseMtManualInvoiceReason = {
  METER_TICKET: 'METER_TICKET',
  VAT_ERROR: 'VAT_ERROR',
  INFORMATION_ERROR: 'INFORMATION_ERROR',
  MISSING_INFORMATION: 'MISSING_INFORMATION',
  DOCUMENT_ERROR: 'DOCUMENT_ERROR',
  OTHER: 'OTHER'
};

exports.ManualInvoiceEventStatus = exports.$Enums.ManualInvoiceEventStatus = {
  CREATED: 'CREATED',
  WAIT_AUTO_APPROVAL: 'WAIT_AUTO_APPROVAL',
  WAIT_AMBLER_APPROVAL: 'WAIT_AMBLER_APPROVAL',
  WAIT_HPTL_APPROVAL: 'WAIT_HPTL_APPROVAL',
  APPROVED: 'APPROVED',
  REFUSED: 'REFUSED',
  DROPPED: 'DROPPED',
  TC_RELAUNCH: 'TC_RELAUNCH',
  TPTR_RELAUNCH: 'TPTR_RELAUNCH',
  TC_APPROVE: 'TC_APPROVE',
  AUTO_APPROVE: 'AUTO_APPROVE',
  LOG_PASSENGER_ADDED: 'LOG_PASSENGER_ADDED',
  LOG_PASSENGER_REMOVED: 'LOG_PASSENGER_REMOVED',
  LOG_MT_CHANGED: 'LOG_MT_CHANGED'
};

exports.MedicalFacilityCategory = exports.$Enums.MedicalFacilityCategory = {
  AELH: 'AELH',
  CHR: 'CHR',
  CH: 'CH',
  CHS: 'CHS',
  CLCC: 'CLCC',
  HL: 'HL',
  SSR: 'SSR',
  USLD: 'USLD',
  EOCG: 'EOCG',
  ESC: 'ESC',
  ESM: 'ESM',
  ESP: 'ESP',
  CMP: 'CMP',
  MSMM: 'MSMM',
  ATT: 'ATT',
  APT: 'APT',
  SMPR: 'SMPR',
  CATTP: 'CATTP',
  CCAP: 'CCAP',
  HAD: 'HAD',
  TSD: 'TSD',
  DC: 'DC',
  DHC: 'DHC',
  EHPAD: 'EHPAD',
  MR: 'MR'
};

exports.MedicalFacilityDepartmentType = exports.$Enums.MedicalFacilityDepartmentType = {
  SSR: 'SSR',
  MCO: 'MCO',
  PSY: 'PSY',
  USLD: 'USLD',
  UHCD: 'UHCD',
  EHPAD: 'EHPAD',
  DC: 'DC',
  DHC: 'DHC',
  CHIM: 'CHIM',
  RC: 'RC',
  RHC: 'RHC',
  HAD: 'HAD',
  MR: 'MR'
};

exports.DispatchType = exports.$Enums.DispatchType = {
  SPLIT: 'SPLIT',
  MERGE: 'MERGE'
};

exports.PatientReminderType = exports.$Enums.PatientReminderType = {
  NONE: 'NONE',
  MF: 'MF',
  MT: 'MT'
};

exports.MedicalFacilityUnitRegulationType = exports.$Enums.MedicalFacilityUnitRegulationType = {
  DISABLED: 'DISABLED',
  ENABLED_DISPATCH_HIDDEN: 'ENABLED_DISPATCH_HIDDEN',
  ENABLED_DISPATCH_VISIBLE: 'ENABLED_DISPATCH_VISIBLE'
};

exports.MedicalFacilityUnitMonitoringType = exports.$Enums.MedicalFacilityUnitMonitoringType = {
  NONE: 'NONE',
  A4HS: 'A4HS',
  A4HL: 'A4HL'
};

exports.HospitalType = exports.$Enums.HospitalType = {
  FULL: 'FULL',
  HDJ: 'HDJ',
  HAD: 'HAD',
  MDV: 'MDV',
  EHPAD: 'EHPAD',
  DC: 'DC',
  RC: 'RC',
  CHIM: 'CHIM',
  URG: 'URG',
  EPA: 'EPA'
};

exports.TransportReasonTemplate = exports.$Enums.TransportReasonTemplate = {
  SSR: 'SSR',
  PSY: 'PSY',
  MCO: 'MCO'
};

exports.MedicalTransporterType = exports.$Enums.MedicalTransporterType = {
  DEFAULT: 'DEFAULT',
  DISPATCHER: 'DISPATCHER',
  AFFILIATE: 'AFFILIATE'
};

exports.PartnershipType = exports.$Enums.PartnershipType = {
  NOT_SIGNED: 'NOT_SIGNED',
  PAYING: 'PAYING'
};

exports.MedicalTransporterGovPricingType = exports.$Enums.MedicalTransporterGovPricingType = {
  CPAM: 'CPAM',
  CPAM_SEFI_GEO: 'CPAM_SEFI_GEO'
};

exports.LegalForm = exports.$Enums.LegalForm = {
  EI: 'EI',
  EIRL: 'EIRL',
  EURL: 'EURL',
  GIE: 'GIE',
  SCA: 'SCA',
  SA: 'SA',
  SARL: 'SARL',
  SAS: 'SAS',
  SASU: 'SASU',
  SCS: 'SCS',
  SCOP: 'SCOP',
  SNC: 'SNC'
};

exports.PassengerVerificationScope = exports.$Enums.PassengerVerificationScope = {
  ALL: 'ALL',
  AGREEMENT: 'AGREEMENT',
  NONE: 'NONE'
};

exports.MedicalTransporterReportType = exports.$Enums.MedicalTransporterReportType = {
  TRIP: 'TRIP',
  DI: 'DI'
};

exports.Gender = exports.$Enums.Gender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  UNKNOWN: 'UNKNOWN'
};

exports.MissionType = exports.$Enums.MissionType = {
  SOLO_SIMPLE: 'SOLO_SIMPLE',
  SOLO_MULTI_AR: 'SOLO_MULTI_AR',
  POOLING_V0: 'POOLING_V0',
  POOLING_MULTI_TRIP: 'POOLING_MULTI_TRIP',
  POOLING_V1: 'POOLING_V1'
};

exports.MissionEventStatus = exports.$Enums.MissionEventStatus = {
  CREATED: 'CREATED',
  ON_HOLD: 'ON_HOLD',
  DELAYED: 'DELAYED',
  EDITED: 'EDITED',
  RELAUNCHED: 'RELAUNCHED',
  REQUESTED: 'REQUESTED',
  ABORTED_NOT_IN_ZONE: 'ABORTED_NOT_IN_ZONE',
  ABORTED_EDIT: 'ABORTED_EDIT',
  ABORTED_MERGED: 'ABORTED_MERGED',
  EDITED_IMPROVED: 'EDITED_IMPROVED',
  ABORTED_BOUNCE: 'ABORTED_BOUNCE',
  WAIT_DISPATCH_STATUS: 'WAIT_DISPATCH_STATUS',
  REPLACED: 'REPLACED',
  DROPPED: 'DROPPED',
  WAIT_GI_TPTR_APPROVAL: 'WAIT_GI_TPTR_APPROVAL',
  WAIT_GI_TPTR_APPROVAL_TIMEOUT: 'WAIT_GI_TPTR_APPROVAL_TIMEOUT',
  WAIT_AUTO_TPTR_APPROVAL: 'WAIT_AUTO_TPTR_APPROVAL',
  WAIT_HPTL_DISPATCH: 'WAIT_HPTL_DISPATCH',
  WAIT_TC_DISPATCH: 'WAIT_TC_DISPATCH',
  PRIORITY_DISPATCH: 'PRIORITY_DISPATCH',
  URGENT_DISPATCH: 'URGENT_DISPATCH',
  TC_DISPATCH_TIMEOUT: 'TC_DISPATCH_TIMEOUT',
  HPTL_DISPATCH_TIMEOUT: 'HPTL_DISPATCH_TIMEOUT',
  TC_TPTR_NOT_FOUND: 'TC_TPTR_NOT_FOUND',
  HPTL_TPTR_NOT_FOUND: 'HPTL_TPTR_NOT_FOUND',
  TC_HPTL_TPTR_NOT_FOUND: 'TC_HPTL_TPTR_NOT_FOUND',
  PREBOOKED: 'PREBOOKED',
  BOOKED: 'BOOKED',
  UNPREBOOKED: 'UNPREBOOKED',
  UNPOOL: 'UNPOOL',
  RECREATE: 'RECREATE',
  REBOOK: 'REBOOK',
  AUTO_PREBOOK: 'AUTO_PREBOOK',
  TIMEOUT_BOOK: 'TIMEOUT_BOOK',
  AUTO_TPTR_ACCEPT: 'AUTO_TPTR_ACCEPT',
  AUTO_TPTR_REFUSE: 'AUTO_TPTR_REFUSE',
  WAIT_AUTO_TPTR_APPROVAL_TIMEOUT: 'WAIT_AUTO_TPTR_APPROVAL_TIMEOUT',
  WAIT_TPTR_APPROVAL_TIMEOUT: 'WAIT_TPTR_APPROVAL_TIMEOUT',
  TPTR_ACCEPT: 'TPTR_ACCEPT',
  TC_PREBOOK: 'TC_PREBOOK',
  TC_DROP: 'TC_DROP',
  TC_TPTR_ACCEPT: 'TC_TPTR_ACCEPT',
  HPTL_TPTR_ACCEPT: 'HPTL_TPTR_ACCEPT',
  TC_CANCEL: 'TC_CANCEL',
  TC_MISSION_ASSIGNED: 'TC_MISSION_ASSIGNED',
  TC_MISSION_UNASSIGNED: 'TC_MISSION_UNASSIGNED',
  DELEGATE_TRIPS: 'DELEGATE_TRIPS',
  UNDELEGATE_TRIPS: 'UNDELEGATE_TRIPS',
  UNDELEGATE_MISSION: 'UNDELEGATE_MISSION',
  TECH_SUPPORT: 'TECH_SUPPORT'
};

exports.MissionStatus = exports.$Enums.MissionStatus = {
  CREATED: 'CREATED',
  ON_HOLD: 'ON_HOLD',
  DELAYED: 'DELAYED',
  EDITED: 'EDITED',
  REQUESTED: 'REQUESTED',
  RELAUNCHED: 'RELAUNCHED',
  ABORTED_NOT_IN_ZONE: 'ABORTED_NOT_IN_ZONE',
  ABORTED_EDIT: 'ABORTED_EDIT',
  ABORTED_MERGED: 'ABORTED_MERGED',
  EDITED_IMPROVED: 'EDITED_IMPROVED',
  ABORTED_BOUNCE: 'ABORTED_BOUNCE',
  WAIT_DISPATCH_STATUS: 'WAIT_DISPATCH_STATUS',
  REPLACED: 'REPLACED',
  DROPPED: 'DROPPED',
  WAIT_GI_TPTR_APPROVAL: 'WAIT_GI_TPTR_APPROVAL',
  WAIT_GI_TPTR_APPROVAL_TIMEOUT: 'WAIT_GI_TPTR_APPROVAL_TIMEOUT',
  WAIT_AUTO_TPTR_APPROVAL: 'WAIT_AUTO_TPTR_APPROVAL',
  WAIT_HPTL_DISPATCH: 'WAIT_HPTL_DISPATCH',
  WAIT_TC_DISPATCH: 'WAIT_TC_DISPATCH',
  PRIORITY_DISPATCH: 'PRIORITY_DISPATCH',
  URGENT_DISPATCH: 'URGENT_DISPATCH',
  TC_DISPATCH_TIMEOUT: 'TC_DISPATCH_TIMEOUT',
  HPTL_DISPATCH_TIMEOUT: 'HPTL_DISPATCH_TIMEOUT',
  TC_TPTR_NOT_FOUND: 'TC_TPTR_NOT_FOUND',
  HPTL_TPTR_NOT_FOUND: 'HPTL_TPTR_NOT_FOUND',
  TC_HPTL_TPTR_NOT_FOUND: 'TC_HPTL_TPTR_NOT_FOUND',
  PREBOOKED: 'PREBOOKED',
  BOOKED: 'BOOKED',
  UNPREBOOKED: 'UNPREBOOKED'
};

exports.PassengerStatus = exports.$Enums.PassengerStatus = {
  CREATED: 'CREATED',
  ON_HOLD: 'ON_HOLD',
  DELAYED: 'DELAYED',
  ABORTED: 'ABORTED',
  ABORTED_MERGED: 'ABORTED_MERGED',
  EDITED_IMPROVED: 'EDITED_IMPROVED',
  REQUESTED: 'REQUESTED',
  DISPATCHING: 'DISPATCHING',
  HPTL_EDIT_DROP: 'HPTL_EDIT_DROP',
  PTNT_DROP: 'PTNT_DROP',
  HPTL_DROP: 'HPTL_DROP',
  TC_PTNT_DROP: 'TC_PTNT_DROP',
  TC_HPTL_DROP: 'TC_HPTL_DROP',
  TC_TPTR_NOT_FOUND: 'TC_TPTR_NOT_FOUND',
  HPTL_TPTR_NOT_FOUND: 'HPTL_TPTR_NOT_FOUND',
  TC_HPTL_TPTR_NOT_FOUND: 'TC_HPTL_TPTR_NOT_FOUND',
  TC_DISPATCH_TIMEOUT: 'TC_DISPATCH_TIMEOUT',
  HPTL_DISPATCH_TIMEOUT: 'HPTL_DISPATCH_TIMEOUT',
  BOOKED: 'BOOKED',
  CHANGED: 'CHANGED',
  PREBOOKED: 'PREBOOKED',
  TC_PTNT_CANCEL: 'TC_PTNT_CANCEL',
  PTNT_CANCEL: 'PTNT_CANCEL',
  HPTL_CANCEL: 'HPTL_CANCEL',
  TC_HPTL_CANCEL: 'TC_HPTL_CANCEL',
  HPTL_EDIT_CANCEL: 'HPTL_EDIT_CANCEL',
  UNBOOKED: 'UNBOOKED',
  UNPREBOOKED: 'UNPREBOOKED',
  RUNNING: 'RUNNING',
  ARRIVED: 'ARRIVED',
  CONFIRMED: 'CONFIRMED',
  SUPPORT: 'SUPPORT',
  PTNT_NORIDE_TPTR_FAULT: 'PTNT_NORIDE_TPTR_FAULT',
  PTNT_NORIDE_PTNT_FAULT: 'PTNT_NORIDE_PTNT_FAULT',
  PTNT_NORIDE_AMBLER_FAULT: 'PTNT_NORIDE_AMBLER_FAULT',
  HPTL_NORIDE_TPTR_FAULT: 'HPTL_NORIDE_TPTR_FAULT',
  HPTL_NORIDE_HPTL_FAULT: 'HPTL_NORIDE_HPTL_FAULT',
  HPTL_NORIDE_AMBLER_FAULT: 'HPTL_NORIDE_AMBLER_FAULT',
  HPTL_NORIDE_PTNT_FAULT: 'HPTL_NORIDE_PTNT_FAULT',
  TPTR_NORIDE_TPTR_FAULT: 'TPTR_NORIDE_TPTR_FAULT',
  TPTR_NORIDE_PTNT_FAULT: 'TPTR_NORIDE_PTNT_FAULT',
  TPTR_NORIDE_HPTL_FAULT: 'TPTR_NORIDE_HPTL_FAULT',
  TPTR_NORIDE_AMBLER_FAULT: 'TPTR_NORIDE_AMBLER_FAULT',
  PTNT_NORIDE_HPTL_FAULT: 'PTNT_NORIDE_HPTL_FAULT',
  WAIT_TPTR_CONFIRMATION: 'WAIT_TPTR_CONFIRMATION',
  WAIT_TC_CONFIRMATION: 'WAIT_TC_CONFIRMATION',
  WAIT_HPTL_CONFIRMATION: 'WAIT_HPTL_CONFIRMATION'
};

exports.OptimizationType = exports.$Enums.OptimizationType = {
  DAY: 'DAY',
  WEEK: 'WEEK'
};

exports.OptimizationRequestStatus = exports.$Enums.OptimizationRequestStatus = {
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
};

exports.OrderStatus = exports.$Enums.OrderStatus = {
  CREATED: 'CREATED',
  TO_PROCESS: 'TO_PROCESS',
  PROCESSING: 'PROCESSING',
  CONFIRMED: 'CONFIRMED',
  ABORTED: 'ABORTED'
};

exports.OrderType = exports.$Enums.OrderType = {
  DEFAULT: 'DEFAULT',
  EDITION: 'EDITION',
  MULTIPLE: 'MULTIPLE',
  RENEW: 'RENEW',
  ENDLESS: 'ENDLESS'
};

exports.OrderItemStatus = exports.$Enums.OrderItemStatus = {
  CREATED: 'CREATED',
  EDITED: 'EDITED',
  CONFIRMED: 'CONFIRMED',
  REPLACED: 'REPLACED',
  ABORTED: 'ABORTED'
};

exports.OrderVehicle = exports.$Enums.OrderVehicle = {
  VSL: 'VSL',
  TAXI: 'TAXI',
  AMBULANCE: 'AMBULANCE',
  TPMR: 'TPMR',
  BARIATRIC: 'BARIATRIC',
  PARAMEDICAL: 'PARAMEDICAL',
  MEDICAL: 'MEDICAL',
  VP: 'VP',
  TC: 'TC',
  TPS: 'TPS'
};

exports.TransportReason = exports.$Enums.TransportReason = {
  HC_CS: 'HC_CS',
  HC_RAD_SCAN: 'HC_RAD_SCAN',
  HC_IMAGE_NOT_RAD_SCAN: 'HC_IMAGE_NOT_RAD_SCAN',
  HC_IMAGE_AND_CS: 'HC_IMAGE_AND_CS',
  HC_TSFR_HPTL_TEMP: 'HC_TSFR_HPTL_TEMP',
  HC_TSFR_FINAL: 'HC_TSFR_FINAL',
  HC_TSFR_URG_TMP_EXAM: 'HC_TSFR_URG_TMP_EXAM',
  HC_TSFR_URG_FINAL: 'HC_TSFR_URG_FINAL',
  HC_ENTER_HPTL: 'HC_ENTER_HPTL',
  HC_DIALYSIS_NOT_HPTL: 'HC_DIALYSIS_NOT_HPTL',
  HC_RADIO_NOT_HPTL: 'HC_RADIO_NOT_HPTL',
  HC_ENTER_PIA: 'HC_ENTER_PIA',
  HC_PERM: 'HC_PERM',
  HC_VISIT_EHPAD: 'HC_VISIT_EHPAD',
  HC_VISIT_EHPAD_PTNT: 'HC_VISIT_EHPAD_PTNT',
  HC_VISIT_EHPAD_HPTL: 'HC_VISIT_EHPAD_HPTL',
  ALD_HPTL: 'ALD_HPTL',
  HC_CS_SAFT: 'HC_CS_SAFT',
  HC_SRE_DETAINEE: 'HC_SRE_DETAINEE',
  HC_SRE_NOT_DETAINEE: 'HC_SRE_NOT_DETAINEE',
  HC_ENTER_CTRTE: 'HC_ENTER_CTRTE',
  HC_CS_FROM_DOM: 'HC_CS_FROM_DOM',
  HC_FUGUE: 'HC_FUGUE',
  HC_TRIBUNAL: 'HC_TRIBUNAL',
  HC_TSFR_ATTENTE: 'HC_TSFR_ATTENTE',
  HC_CHIM_HPTL: 'HC_CHIM_HPTL',
  HC_DIALYSIS_HPTL: 'HC_DIALYSIS_HPTL',
  HC_RADIO_HPTL: 'HC_RADIO_HPTL',
  HC_PERM_CHILD: 'HC_PERM_CHILD',
  HC_VAD: 'HC_VAD',
  HC_SISMO: 'HC_SISMO',
  HC_AUTO_DIALYSIS: 'HC_AUTO_DIALYSIS',
  HC_TSFR_FINAL_NO_CSTMT: 'HC_TSFR_FINAL_NO_CSTMT',
  HC_TSFR_FINAL_CTRTE: 'HC_TSFR_FINAL_CTRTE',
  HC_TSFR_FINAL_ENTER_CTRTE: 'HC_TSFR_FINAL_ENTER_CTRTE',
  HC_TSFR_URG_TMP_HOSPI: 'HC_TSFR_URG_TMP_HOSPI',
  HC_PERM_EHPAD_HPTL: 'HC_PERM_EHPAD_HPTL',
  HC_PERM_EHPAD_PTNT: 'HC_PERM_EHPAD_PTNT',
  HC_KINE: 'HC_KINE',
  HC_EXIT_BABY: 'HC_EXIT_BABY',
  URG_TSFR_UHCD_HPTL: 'URG_TSFR_UHCD_HPTL',
  URG_TSFR_HPTL: 'URG_TSFR_HPTL',
  URG_ENTER_UHCD: 'URG_ENTER_UHCD',
  URG_TSFR_PSYCONS: 'URG_TSFR_PSYCONS',
  URG_TSFR_PSYCONS_FROM_UHCD: 'URG_TSFR_PSYCONS_FROM_UHCD',
  URG_CS: 'URG_CS',
  EHPAD_CS: 'EHPAD_CS',
  EHPAD_RAD_SCAN: 'EHPAD_RAD_SCAN',
  EHPAD_IMAGE_NOT_RAD_SCAN: 'EHPAD_IMAGE_NOT_RAD_SCAN',
  EHPAD_IMAGE_AND_CS: 'EHPAD_IMAGE_AND_CS',
  EHPAD_TSFR_HPTL_TEMP: 'EHPAD_TSFR_HPTL_TEMP',
  EHPAD_TSFR_FINAL: 'EHPAD_TSFR_FINAL',
  EHPAD_TSFR_URG_TMP_EXAM: 'EHPAD_TSFR_URG_TMP_EXAM',
  EHPAD_TSFR_URG_FINAL: 'EHPAD_TSFR_URG_FINAL',
  EHPAD_ENTER: 'EHPAD_ENTER',
  EHPAD_DC_CH_RA: 'EHPAD_DC_CH_RA',
  EHPAD_PERM: 'EHPAD_PERM',
  EHPAD_RADIO: 'EHPAD_RADIO',
  EHPAD_CHIM: 'EHPAD_CHIM',
  EHPAD_DIALYSIS: 'EHPAD_DIALYSIS',
  EHPAD_ADJ: 'EHPAD_ADJ',
  HDJ_FROM_DOM: 'HDJ_FROM_DOM',
  HDJ_TSFR_DOM_FROM_HDJ: 'HDJ_TSFR_DOM_FROM_HDJ',
  HDJ_TSFR_ECOLE_FROM_HDJ: 'HDJ_TSFR_ECOLE_FROM_HDJ',
  HDJ_TSFR_HDJ_FROM_ECOLE: 'HDJ_TSFR_HDJ_FROM_ECOLE',
  HDJ_ACTIVITIES_FROM_HDJ: 'HDJ_ACTIVITIES_FROM_HDJ',
  HDJ_ACTIVITIES_FROM_DOM: 'HDJ_ACTIVITIES_FROM_DOM',
  HDJ_CS: 'HDJ_CS',
  HDJ_IMAGE_AND_CS: 'HDJ_IMAGE_AND_CS',
  HDJ_RAD_SCAN: 'HDJ_RAD_SCAN',
  HDJ_IMAGE_NOT_RAD_SCAN: 'HDJ_IMAGE_NOT_RAD_SCAN',
  HDJ_TSFR_OTHER_FROM_HDJ_HPTLA_NOTART80: 'HDJ_TSFR_OTHER_FROM_HDJ_HPTLA_NOTART80',
  HDJ_TSFR_HDJ_FROM_OTHER_HPTLA_NOTART80: 'HDJ_TSFR_HDJ_FROM_OTHER_HPTLA_NOTART80',
  HDJ_ENTER_PIA: 'HDJ_ENTER_PIA',
  HAD_ENTER: 'HAD_ENTER',
  HAD_TSFR_FINAL: 'HAD_TSFR_FINAL',
  HAD_TSFR_HPTL_TEMP_PRTCL: 'HAD_TSFR_HPTL_TEMP_PRTCL',
  HAD_TSFR_HPTL_TEMP_NOT_PRTCL: 'HAD_TSFR_HPTL_TEMP_NOT_PRTCL',
  HAD_CS_PRTCL: 'HAD_CS_PRTCL',
  HAD_CS_NOT_PRTCL: 'HAD_CS_NOT_PRTCL',
  HAD_RAD_SCAN_PRTCL: 'HAD_RAD_SCAN_PRTCL',
  HAD_RAD_SCAN_NOT_PRTCL: 'HAD_RAD_SCAN_NOT_PRTCL',
  HAD_IMAGE_NOT_RAD_SCAN_PRTCL: 'HAD_IMAGE_NOT_RAD_SCAN_PRTCL',
  HAD_IMAGE_NOT_RAD_SCAN_NOT_PRTCL: 'HAD_IMAGE_NOT_RAD_SCAN_NOT_PRTCL',
  HAD_IMAGE_AND_CS_PRTCL: 'HAD_IMAGE_AND_CS_PRTCL',
  HAD_PSY_SSR_IMAGE_AND_CS_NOT_PRTCL: 'HAD_PSY_SSR_IMAGE_AND_CS_NOT_PRTCL',
  HAD_CHIM_HPTL: 'HAD_CHIM_HPTL',
  HAD_DIALYSIS_HPTL: 'HAD_DIALYSIS_HPTL',
  HAD_RADIO_HPTL: 'HAD_RADIO_HPTL',
  HAD_RADIO_NOT_HPTL: 'HAD_RADIO_NOT_HPTL',
  HAD_DIALYSIS_NOT_HPTL_NOT_PRTCL: 'HAD_DIALYSIS_NOT_HPTL_NOT_PRTCL',
  HAD_DIALYSIS_NOT_HPTL_PRTCL: 'HAD_DIALYSIS_NOT_HPTL_PRTCL',
  HAD_TSFR_URG_FINAL: 'HAD_TSFR_URG_FINAL',
  HAD_TSFR_URG_TMP_EXAM: 'HAD_TSFR_URG_TMP_EXAM',
  DC_SESSION_FROM_DOM: 'DC_SESSION_FROM_DOM',
  DC_SESSION_FROM_HPTL: 'DC_SESSION_FROM_HPTL',
  DC_SESSION_FROM_HAD: 'DC_SESSION_FROM_HAD',
  DC_SCAN_REP: 'DC_SCAN_REP',
  DC_DIALYSIS_ENTRNMT: 'DC_DIALYSIS_ENTRNMT',
  DC_CS: 'DC_CS',
  DC_HC_SESSION_FROM_DOM: 'DC_HC_SESSION_FROM_DOM',
  RC_SESSION_FROM_DOM: 'RC_SESSION_FROM_DOM',
  RC_SESSION_FROM_HPTL: 'RC_SESSION_FROM_HPTL',
  RC_SESSION_FROM_HAD: 'RC_SESSION_FROM_HAD',
  RC_CENTRAGE: 'RC_CENTRAGE',
  RC_IRR_EXT: 'RC_IRR_EXT',
  CHIM_SESSION_FROM_DOM: 'CHIM_SESSION_FROM_DOM',
  CHIM_SESSION_FROM_HPTL: 'CHIM_SESSION_FROM_HPTL',
  CHIM_SESSION_FROM_HAD: 'CHIM_SESSION_FROM_HAD',
  CHIM_CS_AND_BLOOD: 'CHIM_CS_AND_BLOOD',
  MDV_CS_COVID: 'MDV_CS_COVID',
  MDV_CS: 'MDV_CS',
  MDV_RAD_SCAN: 'MDV_RAD_SCAN',
  MDV_IMAGE_NOT_RAD_SCAN: 'MDV_IMAGE_NOT_RAD_SCAN',
  MDV_IMAGE_AND_CS: 'MDV_IMAGE_AND_CS',
  MDV_TSFR_URG_COVID: 'MDV_TSFR_URG_COVID',
  MDV_TSFR_URG: 'MDV_TSFR_URG',
  MDV_ENTER_HPTL: 'MDV_ENTER_HPTL',
  MDV_ENTER_HPTL_HDJ: 'MDV_ENTER_HPTL_HDJ',
  MDV_OTHER: 'MDV_OTHER',
  EPA_CS_NOTART80: 'EPA_CS_NOTART80',
  EPA_RAD_SCAN_NOTART80: 'EPA_RAD_SCAN_NOTART80',
  EPA_IMAGE_AND_CS_NOTART80: 'EPA_IMAGE_AND_CS_NOTART80',
  EPA_IMAGE_NOT_RAD_SCAN_NOTART80: 'EPA_IMAGE_NOT_RAD_SCAN_NOTART80',
  EPA_TSFR_FINAL_GOV: 'EPA_TSFR_FINAL_GOV',
  EPA_TSFR_HPTL_TEMP_NOTART80: 'EPA_TSFR_HPTL_TEMP_NOTART80',
  EPA_TSFR_URG_TMP_EXAM_NOTART80: 'EPA_TSFR_URG_TMP_EXAM_NOTART80',
  EPA_TSFR_URG_FINAL_GOV: 'EPA_TSFR_URG_FINAL_GOV',
  EPA_CHIM_HPTL: 'EPA_CHIM_HPTL',
  EPA_DIALYSIS_HPTL: 'EPA_DIALYSIS_HPTL',
  EPA_RADIO_HPTL: 'EPA_RADIO_HPTL',
  EPA_RADIO_NOT_HPTL: 'EPA_RADIO_NOT_HPTL',
  EPA_ENTER_HPTL: 'EPA_ENTER_HPTL',
  EPA_PERM_NOTART80: 'EPA_PERM_NOTART80',
  EPA_VAD_NOTART80: 'EPA_VAD_NOTART80',
  EPA_VISIT_EHPAD_NOTART80: 'EPA_VISIT_EHPAD_NOTART80',
  EPA_VISIT_EHPAD_PTNT: 'EPA_VISIT_EHPAD_PTNT',
  EPA_CS_FROM_EPA_NOTART80: 'EPA_CS_FROM_EPA_NOTART80',
  EPA_CS_FROM_EPA_PTNT: 'EPA_CS_FROM_EPA_PTNT',
  EPA_CS_FROM_EPA_GOV: 'EPA_CS_FROM_EPA_GOV',
  EPA_TSFR_FROM_EPA_NOTART80: 'EPA_TSFR_FROM_EPA_NOTART80',
  EPA_TSFR_FROM_EPA_PTNT: 'EPA_TSFR_FROM_EPA_PTNT',
  EPA_TSFR_FROM_EPA_GOV: 'EPA_TSFR_FROM_EPA_GOV',
  TPS_HOME: 'TPS_HOME',
  OTHER: 'OTHER',
  ANY_EXIT_HPTL: 'ANY_EXIT_HPTL',
  ANY_RETURN_MED_DEVICE: 'ANY_RETURN_MED_DEVICE',
  ANY_ACH_PRLVT: 'ANY_ACH_PRLVT',
  ANY_EXIT_PRLVT: 'ANY_EXIT_PRLVT',
  ANY_UNINSURED_PTNT: 'ANY_UNINSURED_PTNT',
  ANY_CUSTOM_THIRDPARTY_HPTLA: 'ANY_CUSTOM_THIRDPARTY_HPTLA',
  HC_RETURN_PIA: 'HC_RETURN_PIA'
};

exports.PmtIssuer = exports.$Enums.PmtIssuer = {
  ORIGIN: 'ORIGIN',
  DESTINATION: 'DESTINATION',
  MFU: 'MFU'
};

exports.Direction = exports.$Enums.Direction = {
  OUTBOUND: 'OUTBOUND',
  INBOUND: 'INBOUND'
};

exports.TimeReference = exports.$Enums.TimeReference = {
  DEPARTURE: 'DEPARTURE',
  ARRIVAL: 'ARRIVAL',
  UNKNOWN: 'UNKNOWN'
};

exports.GovFlatRateType = exports.$Enums.GovFlatRateType = {
  TDE_MCO: 'TDE_MCO',
  TSE_MCO: 'TSE_MCO',
  ST1_SSR: 'ST1_SSR',
  ST1_PSY: 'ST1_PSY',
  ST2_SSR: 'ST2_SSR',
  ST2_PSY: 'ST2_PSY',
  ST3_SSR: 'ST3_SSR',
  ST3_PSY: 'ST3_PSY',
  ST1_SSR_0_25: 'ST1_SSR_0_25',
  ST1_SSR_25_75: 'ST1_SSR_25_75',
  ST1_SSR_75_150: 'ST1_SSR_75_150',
  ST1_SSR_150_300: 'ST1_SSR_150_300',
  ST1_SSR_300: 'ST1_SSR_300',
  ST1_PSY_0_25: 'ST1_PSY_0_25',
  ST1_PSY_25_75: 'ST1_PSY_25_75',
  ST1_PSY_75_150: 'ST1_PSY_75_150',
  ST1_PSY_150_300: 'ST1_PSY_150_300',
  ST1_PSY_300: 'ST1_PSY_300',
  TDE_MCO_0_25: 'TDE_MCO_0_25',
  TDE_MCO_25_75: 'TDE_MCO_25_75',
  TDE_MCO_75_150: 'TDE_MCO_75_150',
  TDE_MCO_150_300: 'TDE_MCO_150_300',
  TDE_MCO_300: 'TDE_MCO_300',
  TSE_MCO_0_40: 'TSE_MCO_0_40',
  TSE_MCO_40_80: 'TSE_MCO_40_80',
  TSE_MCO_80_160: 'TSE_MCO_80_160',
  TSE_MCO_160: 'TSE_MCO_160',
  ST2_PSY_0_20: 'ST2_PSY_0_20',
  ST2_PSY_20_50: 'ST2_PSY_20_50',
  ST2_PSY_50_120: 'ST2_PSY_50_120',
  ST2_PSY_120: 'ST2_PSY_120',
  ST2_SSR_0_20: 'ST2_SSR_0_20',
  ST2_SSR_20_50: 'ST2_SSR_20_50',
  ST2_SSR_50_120: 'ST2_SSR_50_120',
  ST2_SSR_120: 'ST2_SSR_120',
  ST3_PSY_0_20: 'ST3_PSY_0_20',
  ST3_PSY_20_50: 'ST3_PSY_20_50',
  ST3_PSY_50_120: 'ST3_PSY_50_120',
  ST3_PSY_120: 'ST3_PSY_120',
  ST3_SSR_0_20: 'ST3_SSR_0_20',
  ST3_SSR_20_50: 'ST3_SSR_20_50',
  ST3_SSR_50_120: 'ST3_SSR_50_120',
  ST3_SSR_120: 'ST3_SSR_120',
  ST4_0_25: 'ST4_0_25',
  ST4_25_75: 'ST4_25_75',
  ST4_75_150: 'ST4_75_150',
  ST4_150_300: 'ST4_150_300',
  ST4_300: 'ST4_300',
  ST5_0_20: 'ST5_0_20',
  ST5_20_50: 'ST5_20_50',
  ST5_50_120: 'ST5_50_120',
  ST5_120: 'ST5_120',
  ST6_0_20: 'ST6_0_20',
  ST6_20_50: 'ST6_20_50',
  ST6_50_120: 'ST6_50_120',
  ST6_120: 'ST6_120'
};

exports.GovFlatRateVerificationStatus = exports.$Enums.GovFlatRateVerificationStatus = {
  NOT_VERIFIED: 'NOT_VERIFIED',
  VERIFIED: 'VERIFIED',
  NEED_MF_CHECK: 'NEED_MF_CHECK'
};

exports.PassengerEventStatus = exports.$Enums.PassengerEventStatus = {
  CREATED: 'CREATED',
  ON_HOLD: 'ON_HOLD',
  DELAYED: 'DELAYED',
  ABORTED: 'ABORTED',
  ABORTED_MERGED: 'ABORTED_MERGED',
  EDITED_IMPROVED: 'EDITED_IMPROVED',
  REQUESTED: 'REQUESTED',
  DISPATCHING: 'DISPATCHING',
  HPTL_EDIT_DROP: 'HPTL_EDIT_DROP',
  PTNT_DROP: 'PTNT_DROP',
  HPTL_DROP: 'HPTL_DROP',
  TC_PTNT_DROP: 'TC_PTNT_DROP',
  TC_HPTL_DROP: 'TC_HPTL_DROP',
  TC_TPTR_NOT_FOUND: 'TC_TPTR_NOT_FOUND',
  HPTL_TPTR_NOT_FOUND: 'HPTL_TPTR_NOT_FOUND',
  TC_HPTL_TPTR_NOT_FOUND: 'TC_HPTL_TPTR_NOT_FOUND',
  TC_DISPATCH_TIMEOUT: 'TC_DISPATCH_TIMEOUT',
  HPTL_DISPATCH_TIMEOUT: 'HPTL_DISPATCH_TIMEOUT',
  PREBOOKED: 'PREBOOKED',
  BOOKED: 'BOOKED',
  CHANGED: 'CHANGED',
  TC_PTNT_CANCEL: 'TC_PTNT_CANCEL',
  PTNT_CANCEL: 'PTNT_CANCEL',
  HPTL_EDIT_CANCEL: 'HPTL_EDIT_CANCEL',
  TC_HPTL_CANCEL: 'TC_HPTL_CANCEL',
  HPTL_CANCEL: 'HPTL_CANCEL',
  UNBOOKED: 'UNBOOKED',
  UNPREBOOKED: 'UNPREBOOKED',
  RUNNING: 'RUNNING',
  ARRIVED: 'ARRIVED',
  CONFIRMED: 'CONFIRMED',
  SUPPORT: 'SUPPORT',
  PTNT_NORIDE_TPTR_FAULT: 'PTNT_NORIDE_TPTR_FAULT',
  PTNT_NORIDE_HPTL_FAULT: 'PTNT_NORIDE_HPTL_FAULT',
  PTNT_NORIDE_PTNT_FAULT: 'PTNT_NORIDE_PTNT_FAULT',
  PTNT_NORIDE_AMBLER_FAULT: 'PTNT_NORIDE_AMBLER_FAULT',
  HPTL_NORIDE_TPTR_FAULT: 'HPTL_NORIDE_TPTR_FAULT',
  HPTL_NORIDE_HPTL_FAULT: 'HPTL_NORIDE_HPTL_FAULT',
  HPTL_NORIDE_AMBLER_FAULT: 'HPTL_NORIDE_AMBLER_FAULT',
  HPTL_NORIDE_PTNT_FAULT: 'HPTL_NORIDE_PTNT_FAULT',
  TPTR_NORIDE_TPTR_FAULT: 'TPTR_NORIDE_TPTR_FAULT',
  TPTR_NORIDE_PTNT_FAULT: 'TPTR_NORIDE_PTNT_FAULT',
  TPTR_NORIDE_HPTL_FAULT: 'TPTR_NORIDE_HPTL_FAULT',
  TPTR_NORIDE_AMBLER_FAULT: 'TPTR_NORIDE_AMBLER_FAULT',
  WAIT_TPTR_CONFIRMATION: 'WAIT_TPTR_CONFIRMATION',
  WAIT_TC_CONFIRMATION: 'WAIT_TC_CONFIRMATION',
  WAIT_HPTL_CONFIRMATION: 'WAIT_HPTL_CONFIRMATION',
  HPTL_UNBOOK: 'HPTL_UNBOOK',
  TC_UNBOOK: 'TC_UNBOOK',
  TPTR_UNBOOK: 'TPTR_UNBOOK',
  HPTL_CANCEL_POST_BOOKED: 'HPTL_CANCEL_POST_BOOKED',
  TC_CANCEL_POST_BOOKED: 'TC_CANCEL_POST_BOOKED',
  AUTO_CONFIRM: 'AUTO_CONFIRM',
  PTNT_NORIDE: 'PTNT_NORIDE',
  HPTL_NORIDE: 'HPTL_NORIDE',
  HPTL_NORIDE_LATE_CANCEL: 'HPTL_NORIDE_LATE_CANCEL',
  TPTR_NORIDE: 'TPTR_NORIDE',
  HPTL_ORDER_ERROR: 'HPTL_ORDER_ERROR',
  TPTR_ORDER_ERROR: 'TPTR_ORDER_ERROR',
  HPTL_LATE_CANCEL: 'HPTL_LATE_CANCEL',
  TC_HPTL_LATE_CANCEL: 'TC_HPTL_LATE_CANCEL',
  PTNT_LATE_CANCEL: 'PTNT_LATE_CANCEL',
  TC_PTNT_LATE_CANCEL: 'TC_PTNT_LATE_CANCEL',
  TPTR_CONFIRM: 'TPTR_CONFIRM',
  TC_TPTR_CONFIRM: 'TC_TPTR_CONFIRM',
  HPTL_CONFIRM: 'HPTL_CONFIRM',
  TC_HPTL_CONFIRM: 'TC_HPTL_CONFIRM',
  TC_GOVFLATRATE_VERIFIED: 'TC_GOVFLATRATE_VERIFIED',
  AUTO_GOVFLATRATE_VERIFIED: 'AUTO_GOVFLATRATE_VERIFIED',
  AUTO_GOVFLATRATE_FLAGGED: 'AUTO_GOVFLATRATE_FLAGGED',
  HPTL_GOVFLATRATE_VERIFIED: 'HPTL_GOVFLATRATE_VERIFIED',
  TC_INCIDENT_RESOLVED: 'TC_INCIDENT_RESOLVED',
  TC_TRANSPORT_REASON_CHANGED: 'TC_TRANSPORT_REASON_CHANGED',
  TC_PRESCRIPTOR_PAYER_CHANGED: 'TC_PRESCRIPTOR_PAYER_CHANGED',
  TC_PAYMENT_STATUS_CHANGED: 'TC_PAYMENT_STATUS_CHANGED',
  TC_GOV_FLAT_RATE_CHANGED: 'TC_GOV_FLAT_RATE_CHANGED',
  GOV_FLAT_RATE_CHANGED: 'GOV_FLAT_RATE_CHANGED',
  TECH_SUPPORT: 'TECH_SUPPORT',
  PATIENT_VISIT_ID_CHANGED: 'PATIENT_VISIT_ID_CHANGED',
  DEPARTURE_TIME_CHANGED: 'DEPARTURE_TIME_CHANGED',
  MISSION_DELEGATED: 'MISSION_DELEGATED',
  MISSION_UNDELEGATED: 'MISSION_UNDELEGATED',
  OVERRIDE_APPLIED: 'OVERRIDE_APPLIED'
};

exports.PassengerIncidentType = exports.$Enums.PassengerIncidentType = {
  HPTL_FLAG_DELAY: 'HPTL_FLAG_DELAY',
  HPTL_FLAG_PTNT_MISS: 'HPTL_FLAG_PTNT_MISS',
  HPTL_FLAG_ORDER_ERROR: 'HPTL_FLAG_ORDER_ERROR',
  HPTL_FLAG_PTNT_LEFT: 'HPTL_FLAG_PTNT_LEFT',
  HPTL_FLAG_NO_RETURN_RIDE: 'HPTL_FLAG_NO_RETURN_RIDE',
  HPTL_FLAG_LATE_CANCEL: 'HPTL_FLAG_LATE_CANCEL',
  HPTL_FLAG_AUTO_LATE_CANCEL: 'HPTL_FLAG_AUTO_LATE_CANCEL',
  HPTL_FLAG_OTHER: 'HPTL_FLAG_OTHER',
  HPTL_FLAG_OUTBOUND_DELAY: 'HPTL_FLAG_OUTBOUND_DELAY',
  HPTL_FLAG_INBOUND_DELAY: 'HPTL_FLAG_INBOUND_DELAY',
  HPTL_FLAG_MT_MISCONDUCT: 'HPTL_FLAG_MT_MISCONDUCT',
  HPTL_FLAG_ORDER_INSTRUCTIONS_NOT_RESPECTED: 'HPTL_FLAG_ORDER_INSTRUCTIONS_NOT_RESPECTED',
  HPTL_FLAG_MT_NO_SHOW: 'HPTL_FLAG_MT_NO_SHOW',
  HPTL_FLAG_PTNT_CANCEL: 'HPTL_FLAG_PTNT_CANCEL',
  HPTL_FLAG_PTNT_CANCEL_TO_VERIFY: 'HPTL_FLAG_PTNT_CANCEL_TO_VERIFY',
  TPTR_FLAG_ORDER_ERROR: 'TPTR_FLAG_ORDER_ERROR',
  TPTR_FLAG_NO_RETURN_RIDE: 'TPTR_FLAG_NO_RETURN_RIDE',
  TPTR_FLAG_LATE_CANCEL: 'TPTR_FLAG_LATE_CANCEL',
  TPTR_FLAG_PTNT_LEFT: 'TPTR_FLAG_PTNT_LEFT',
  TPTR_FLAG_PTNT_UNCOMPAT: 'TPTR_FLAG_PTNT_UNCOMPAT',
  TPTR_FLAG_RDV_MISS: 'TPTR_FLAG_RDV_MISS',
  TPTR_FLAG_VEHICLE_UNAVAILABLE: 'TPTR_FLAG_VEHICLE_UNAVAILABLE',
  TPTR_FLAG_DOCUMENTS_NOTREADY: 'TPTR_FLAG_DOCUMENTS_NOTREADY',
  TPTR_FLAG_PTNT_NOTREADY: 'TPTR_FLAG_PTNT_NOTREADY',
  TPTR_FLAG_NO_RIDE_PTNT_NOTREADY: 'TPTR_FLAG_NO_RIDE_PTNT_NOTREADY',
  TPTR_FLAG_OTHER: 'TPTR_FLAG_OTHER',
  TPTR_FLAG_DUPLICATED_ORDER: 'TPTR_FLAG_DUPLICATED_ORDER',
  TPTR_FLAG_PICKUP_TIME_CHANGE: 'TPTR_FLAG_PICKUP_TIME_CHANGE',
  TPTR_FLAG_WAITING_FOR_DOCUMENTS: 'TPTR_FLAG_WAITING_FOR_DOCUMENTS',
  TPTR_FLAG_ADD_COMMENT: 'TPTR_FLAG_ADD_COMMENT',
  TPTR_FLAG_ADDRESS_OR_DATE_CHANGE: 'TPTR_FLAG_ADDRESS_OR_DATE_CHANGE',
  TPTR_FLAG_VEHICLE_CHANGE: 'TPTR_FLAG_VEHICLE_CHANGE',
  TPTR_FLAG_WRONG_DOCUMENTS: 'TPTR_FLAG_WRONG_DOCUMENTS',
  TPTR_FLAG_SUGGEST_PAYER_CHANGE: 'TPTR_FLAG_SUGGEST_PAYER_CHANGE',
  TPTR_FLAG_PATIENT_NOT_READY_FOR_DISCHARGE: 'TPTR_FLAG_PATIENT_NOT_READY_FOR_DISCHARGE',
  TPTR_FLAG_ORDER_MISSING_INFORMATION: 'TPTR_FLAG_ORDER_MISSING_INFORMATION',
  TPTR_FLAG_WAITING_FEE_REQUESTED: 'TPTR_FLAG_WAITING_FEE_REQUESTED',
  TPTR_FLAG_TRIP_DELEGATED: 'TPTR_FLAG_TRIP_DELEGATED',
  TPTR_FLAG_PTNT_CANCEL: 'TPTR_FLAG_PTNT_CANCEL',
  TPTR_FLAG_PTNT_CANCEL_TO_VERIFY: 'TPTR_FLAG_PTNT_CANCEL_TO_VERIFY'
};

exports.PhoneType = exports.$Enums.PhoneType = {
  MOBILE: 'MOBILE',
  FIXED_LINE: 'FIXED_LINE'
};

exports.IconType = exports.$Enums.IconType = {
  HOSPITAL: 'HOSPITAL'
};

exports.PrescriptionType = exports.$Enums.PrescriptionType = {
  CERFA: 'CERFA',
  CERFA_WITH_IMPORT: 'CERFA_WITH_IMPORT',
  CERFA_WITH_SIGNATURE: 'CERFA_WITH_SIGNATURE',
  ART80: 'ART80',
  ART80_WITH_SIGNATURE: 'ART80_WITH_SIGNATURE'
};

exports.PrescriptionVehicle = exports.$Enums.PrescriptionVehicle = {
  VP: 'VP',
  TC: 'TC',
  TAP: 'TAP',
  AMBULANCE: 'AMBULANCE',
  TPMR: 'TPMR',
  BARIATRIC: 'BARIATRIC',
  PARAMEDICAL: 'PARAMEDICAL',
  MEDICAL: 'MEDICAL'
};

exports.InvoicingFrequency = exports.$Enums.InvoicingFrequency = {
  WEEKLY: 'WEEKLY',
  SEMI_MONTHLY: 'SEMI_MONTHLY',
  MONTHLY: 'MONTHLY'
};

exports.PaymentModality = exports.$Enums.PaymentModality = {
  DAYS: 'DAYS',
  DAYS_END_OF_MONTH: 'DAYS_END_OF_MONTH'
};

exports.AgreementType = exports.$Enums.AgreementType = {
  BILLING: 'BILLING',
  PRICING: 'PRICING',
  RESERVE: 'RESERVE'
};

exports.GovPriceInfoFunction = exports.$Enums.GovPriceInfoFunction = {
  GOV_CPAM_TAP_2020_06_11: 'GOV_CPAM_TAP_2020_06_11',
  GOV_CPAM_AMBULANCE_2020_06_11: 'GOV_CPAM_AMBULANCE_2020_06_11',
  GOV_CPAM_TAP_2021_03_15: 'GOV_CPAM_TAP_2021_03_15',
  GOV_CPAM_AMBULANCE_2021_03_15: 'GOV_CPAM_AMBULANCE_2021_03_15',
  GOV_CPAM_TAP_2023_11_07: 'GOV_CPAM_TAP_2023_11_07',
  GOV_CPAM_AMBULANCE_2023_11_07: 'GOV_CPAM_AMBULANCE_2023_11_07',
  GOV_CPAM_SEFI_GEO_TAP_2024_05_06: 'GOV_CPAM_SEFI_GEO_TAP_2024_05_06',
  GOV_CPAM_SEFI_GEO_AMBULANCE_2024_05_06: 'GOV_CPAM_SEFI_GEO_AMBULANCE_2024_05_06',
  GOV_CPAM_SEFI_GEO_TAP_2025_01_01: 'GOV_CPAM_SEFI_GEO_TAP_2025_01_01',
  GOV_CPAM_SEFI_GEO_AMBULANCE_2025_01_01: 'GOV_CPAM_SEFI_GEO_AMBULANCE_2025_01_01',
  GOV_TAXI_69: 'GOV_TAXI_69',
  GOV_TAXI_67: 'GOV_TAXI_67'
};

exports.PricingTimeSlot = exports.$Enums.PricingTimeSlot = {
  NIGHT: 'NIGHT',
  SATURDAY: 'SATURDAY',
  SUNDAY: 'SUNDAY',
  HOLIDAY: 'HOLIDAY',
  WEEKDAY: 'WEEKDAY'
};

exports.PricingType = exports.$Enums.PricingType = {
  CPAM: 'CPAM',
  CPAM_SEFI_GEO: 'CPAM_SEFI_GEO',
  CUSTOM: 'CUSTOM'
};

exports.VehiclePricingType = exports.$Enums.VehiclePricingType = {
  TAP: 'TAP',
  AMBULANCE: 'AMBULANCE'
};

exports.RavenType = exports.$Enums.RavenType = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  GTWEB: 'GTWEB',
  ELISA: 'ELISA',
  SAPHYR: 'SAPHYR',
  APPSOLU: 'APPSOLU',
  WEBPUSH: 'WEBPUSH',
  APPPUSH: 'APPPUSH',
  PHONE: 'PHONE',
  PENNYLANE: 'PENNYLANE'
};

exports.PhoneRavenStatus = exports.$Enums.PhoneRavenStatus = {
  ANSWERED: 'ANSWERED',
  UNANSWERED: 'UNANSWERED',
  UNKNOWN: 'UNKNOWN'
};

exports.TaskType = exports.$Enums.TaskType = {
  DISPATCH_NOT_CONFIRMED_CALLMF: 'DISPATCH_NOT_CONFIRMED_CALLMF',
  DISPATCH_SET_MISSING_PAYER: 'DISPATCH_SET_MISSING_PAYER',
  PASSENGER_SET_MISSING_PAYMENT: 'PASSENGER_SET_MISSING_PAYMENT',
  DISPATCH_WATCH_PREFERRED_MT: 'DISPATCH_WATCH_PREFERRED_MT',
  DISPATCH_CHECK_GOV_FLATRATE: 'DISPATCH_CHECK_GOV_FLATRATE',
  DISPATCH_CHECK_UNKNOWN_ADDR: 'DISPATCH_CHECK_UNKNOWN_ADDR',
  DISPATCH_TO_DISPATCH: 'DISPATCH_TO_DISPATCH',
  DISPATCH_EDITED_CALLMT: 'DISPATCH_EDITED_CALLMT',
  DISPATCH_EDITED_NOACCOUNT: 'DISPATCH_EDITED_NOACCOUNT',
  DISPATCH_DISPATCHING: 'DISPATCH_DISPATCHING',
  DISPATCH_RESEND_BR_RAVENS_SCHEDULED: 'DISPATCH_RESEND_BR_RAVENS_SCHEDULED',
  DISPATCH_TPTR_NOT_FOUND_TIMEOUT: 'DISPATCH_TPTR_NOT_FOUND_TIMEOUT',
  DISPATCH_NOT_ASSIGNED_TC_TIMEOUT: 'DISPATCH_NOT_ASSIGNED_TC_TIMEOUT',
  DISPATCH_PREBOOKED_CALLMT: 'DISPATCH_PREBOOKED_CALLMT',
  DISPATCH_A4D_PREBOOKED_CALLMT: 'DISPATCH_A4D_PREBOOKED_CALLMT',
  DISPATCH_INTEGRATION_ERROR: 'DISPATCH_INTEGRATION_ERROR',
  DISPATCH_BOOKED_CALLPATIENT: 'DISPATCH_BOOKED_CALLPATIENT',
  DISPATCH_CALL_MF: 'DISPATCH_CALL_MF',
  DISPATCH_MT_COUNTEROFFER: 'DISPATCH_MT_COUNTEROFFER',
  INCIDENT_RESOLVE_MAJOR_INCIDENT: 'INCIDENT_RESOLVE_MAJOR_INCIDENT',
  INCIDENT_RESOLVE_MINOR_INCIDENT: 'INCIDENT_RESOLVE_MINOR_INCIDENT',
  CANCEL_CALLMT: 'CANCEL_CALLMT',
  CANCEL_INTEGRATION_ERROR: 'CANCEL_INTEGRATION_ERROR',
  INVOICING_RELAUNCH_INVOICE: 'INVOICING_RELAUNCH_INVOICE',
  INVOICING_PENDING_MT_APPROVAL_5D: 'INVOICING_PENDING_MT_APPROVAL_5D',
  INVOICING_PENDING_MT_APPROVAL_10D: 'INVOICING_PENDING_MT_APPROVAL_10D',
  INVOICING_PENDING_MT_APPROVAL_20D: 'INVOICING_PENDING_MT_APPROVAL_20D',
  INVOICING_PENDING_MT_APPROVAL_FINAL: 'INVOICING_PENDING_MT_APPROVAL_FINAL',
  INVOICING_MISSING_TRIPS: 'INVOICING_MISSING_TRIPS',
  INVOICING_MISSING_TRIP: 'INVOICING_MISSING_TRIP',
  INVOICING_MISSING_DI: 'INVOICING_MISSING_DI',
  INVOICING_INVOICE_TO_BE_SENT_MANUALLY: 'INVOICING_INVOICE_TO_BE_SENT_MANUALLY',
  PASSENGER_PENDING_TC_CONFIRMATION: 'PASSENGER_PENDING_TC_CONFIRMATION',
  INVOICING_CHECK_POST_APPROVAL_MODIFICATION: 'INVOICING_CHECK_POST_APPROVAL_MODIFICATION',
  MANUAL_INVOICING_SEND_INVOICE: 'MANUAL_INVOICING_SEND_INVOICE',
  MANUAL_INVOICING_SEND_MODIFIED_INVOICE: 'MANUAL_INVOICING_SEND_MODIFIED_INVOICE',
  MANUAL_INVOICING_UPLOAD_INVOICE: 'MANUAL_INVOICING_UPLOAD_INVOICE',
  MANUAL_INVOICING_CHECK_PASSENGER_INCIDENT_RESOLUTION: 'MANUAL_INVOICING_CHECK_PASSENGER_INCIDENT_RESOLUTION',
  MANUAL_INVOICING_MISSING_TRIP: 'MANUAL_INVOICING_MISSING_TRIP',
  MANUAL_INVOICING_MISSING_DI: 'MANUAL_INVOICING_MISSING_DI',
  ACCOUNTING_CHECK_MODIFICATION_REQUEST: 'ACCOUNTING_CHECK_MODIFICATION_REQUEST',
  ACCOUNTING_RELAUNCH_INVOICING: 'ACCOUNTING_RELAUNCH_INVOICING',
  ACCOUNTING_SEPA_EXPIRED: 'ACCOUNTING_SEPA_EXPIRED',
  ACCOUNTING_EMAILS_BLOCKED: 'ACCOUNTING_EMAILS_BLOCKED',
  ACCOUNTING_UPLOAD_TO_CHORUS: 'ACCOUNTING_UPLOAD_TO_CHORUS',
  A4D_DISPATCH_AUTO_DISPATCHING: 'A4D_DISPATCH_AUTO_DISPATCHING',
  A4D_DISPATCH_DISPATCHING: 'A4D_DISPATCH_DISPATCHING',
  A4D_DISPATCH_TO_DISPATCH: 'A4D_DISPATCH_TO_DISPATCH',
  A4D_PREBOOKED_AUTO_DISPATCHING: 'A4D_PREBOOKED_AUTO_DISPATCHING',
  A4D_PREBOOKED_DISPATCHING: 'A4D_PREBOOKED_DISPATCHING',
  A4D_PREBOOKED_TO_DISPATCH: 'A4D_PREBOOKED_TO_DISPATCH',
  A4D_DISPATCH_EDITED_CALLMT: 'A4D_DISPATCH_EDITED_CALLMT',
  A4D_CANCEL_CALLMT: 'A4D_CANCEL_CALLMT',
  OPTIM_PATIENT_TO_ADD: 'OPTIM_PATIENT_TO_ADD',
  OPTIM_TO_CREATE: 'OPTIM_TO_CREATE',
  HIDDEN_URGENT_DISPATCH_IS_SOON: 'HIDDEN_URGENT_DISPATCH_IS_SOON'
};

exports.TaskStatus = exports.$Enums.TaskStatus = {
  WAITING: 'WAITING',
  PENDING: 'PENDING',
  TERMINATED: 'TERMINATED'
};

exports.TaskScope = exports.$Enums.TaskScope = {
  DISPATCH: 'DISPATCH',
  INCIDENT: 'INCIDENT',
  CANCEL: 'CANCEL',
  INVOICING: 'INVOICING',
  MANUAL_INVOICING: 'MANUAL_INVOICING',
  AMBLER_INVOICING: 'AMBLER_INVOICING',
  DISPATCHER: 'DISPATCHER',
  OPTIM: 'OPTIM',
  HIDDEN: 'HIDDEN'
};

exports.TdrContractType = exports.$Enums.TdrContractType = {
  CLASSIC: 'CLASSIC',
  OPTIM: 'OPTIM'
};

exports.PricingPoolingDiscount = exports.$Enums.PricingPoolingDiscount = {
  NONE: 'NONE',
  POOLING_2_DISCOUNT: 'POOLING_2_DISCOUNT',
  POOLING_3_DISCOUNT: 'POOLING_3_DISCOUNT'
};

exports.UserRole = exports.$Enums.UserRole = {
  ADMIN: 'ADMIN',
  EDITOR: 'EDITOR',
  USER: 'USER'
};

exports.MfuEmailRecipients = exports.$Enums.MfuEmailRecipients = {
  NONE: 'NONE',
  REQUESTER_ONLY: 'REQUESTER_ONLY',
  ALL_MFU: 'ALL_MFU'
};

exports.SignatureRightScope = exports.$Enums.SignatureRightScope = {
  ART80: 'ART80',
  CERFA_AND_ART80: 'CERFA_AND_ART80'
};

exports.AmblerInvoiceStatus = exports.$Enums.AmblerInvoiceStatus = {
  WAIT_INVOICEE_APPROVAL: 'WAIT_INVOICEE_APPROVAL',
  WAIT_TC_RELAUNCH: 'WAIT_TC_RELAUNCH',
  WAIT_AUTO_RELAUNCH: 'WAIT_AUTO_RELAUNCH',
  DROPPED: 'DROPPED',
  REPLACED: 'REPLACED',
  CANCELED: 'CANCELED',
  APPROVED: 'APPROVED'
};

exports.AmblerInvoiceEventStatus = exports.$Enums.AmblerInvoiceEventStatus = {
  WAIT_INVOICEE_APPROVAL: 'WAIT_INVOICEE_APPROVAL',
  WAIT_TC_RELAUNCH: 'WAIT_TC_RELAUNCH',
  WAIT_AUTO_RELAUNCH: 'WAIT_AUTO_RELAUNCH',
  DROPPED: 'DROPPED',
  REPLACED: 'REPLACED',
  CANCELED: 'CANCELED',
  APPROVED: 'APPROVED',
  AUTO_CREATE: 'AUTO_CREATE',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  AUTO_APPROVE: 'AUTO_APPROVE',
  TC_ACCEPT_MODIFICATION_REQUEST: 'TC_ACCEPT_MODIFICATION_REQUEST',
  TC_DECLINE_MODIFICATION_REQUEST: 'TC_DECLINE_MODIFICATION_REQUEST',
  TECH_SUPPORT: 'TECH_SUPPORT'
};

exports.AmblerInvoiceType = exports.$Enums.AmblerInvoiceType = {
  TDR: 'TDR',
  A4C: 'A4C',
  A4HL: 'A4HL',
  A4HS: 'A4HS',
  ALD: 'ALD',
  PREST: 'PREST'
};

exports.BookingRequestEventStatus = exports.$Enums.BookingRequestEventStatus = {
  WAITING: 'WAITING',
  PENDING: 'PENDING',
  PROTECTED: 'PROTECTED',
  COUNTER_OFFER_PENDING: 'COUNTER_OFFER_PENDING',
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
  DUPLICATED: 'DUPLICATED',
  HPTL_ACCEPTED: 'HPTL_ACCEPTED',
  TC_ACCEPTED: 'TC_ACCEPTED',
  TPTR_ACCEPTED: 'TPTR_ACCEPTED',
  AUTO_ACCEPTED: 'AUTO_ACCEPTED',
  HPTL_REFUSED: 'HPTL_REFUSED',
  TC_REFUSED: 'TC_REFUSED',
  TPTR_REFUSED: 'TPTR_REFUSED',
  HOLIDAY_REFUSED: 'HOLIDAY_REFUSED',
  BLACKLISTED: 'BLACKLISTED',
  NOT_SENT: 'NOT_SENT',
  TC_COUNTER_OFFER: 'TC_COUNTER_OFFER',
  MT_COUNTER_OFFER: 'MT_COUNTER_OFFER',
  HPTL_SENT: 'HPTL_SENT',
  TC_SENT: 'TC_SENT',
  AUTO_SENT: 'AUTO_SENT',
  TC_RESEND: 'TC_RESEND'
};

exports.MedicalTransporterReviewRequestedChangeType = exports.$Enums.MedicalTransporterReviewRequestedChangeType = {
  DI: 'DI',
  PRICING_INCREASE_POOLING_DISCOUNT: 'PRICING_INCREASE_POOLING_DISCOUNT',
  PRICING_DECREASE_POOLING_DISCOUNT: 'PRICING_DECREASE_POOLING_DISCOUNT',
  PRICING_APPLY_WAITING_FEE: 'PRICING_APPLY_WAITING_FEE',
  DISTANCE: 'DISTANCE',
  PRICING_KM: 'PRICING_KM',
  PRICING_TIMESLOT: 'PRICING_TIMESLOT',
  PRICING_TOLL: 'PRICING_TOLL',
  PRICE: 'PRICE'
};

exports.MedicalTransporterReviewRequestedChangeEventType = exports.$Enums.MedicalTransporterReviewRequestedChangeEventType = {
  AUTO: 'AUTO',
  HPTL_ACCEPTED: 'HPTL_ACCEPTED',
  HPTL_REFUSED: 'HPTL_REFUSED'
};

exports.PostApprovalInvoiceModificationType = exports.$Enums.PostApprovalInvoiceModificationType = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  UPDATE: 'UPDATE'
};

exports.AmblerInvoicingModificationRequestType = exports.$Enums.AmblerInvoicingModificationRequestType = {
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  UPDATE: 'UPDATE',
  DROP: 'DROP'
};

exports.PassengerCancelationType = exports.$Enums.PassengerCancelationType = {
  HPTL_PTNT_NOT_READY: 'HPTL_PTNT_NOT_READY',
  HPTL_PTNT_LEFT: 'HPTL_PTNT_LEFT',
  HPTL_ORDER_ERROR: 'HPTL_ORDER_ERROR',
  HPTL_APPOINTMENT_CANCELED: 'HPTL_APPOINTMENT_CANCELED',
  HPTL_PTNT_CANCELED: 'HPTL_PTNT_CANCELED',
  HPTL_PTNT_SCHEDULE_CHANGED: 'HPTL_PTNT_SCHEDULE_CHANGED',
  HPTL_PTNT_SCHEDULE_ENDED: 'HPTL_PTNT_SCHEDULE_ENDED',
  HPTL_TPTR_NOT_FOUND: 'HPTL_TPTR_NOT_FOUND',
  HPTL_OTHER: 'HPTL_OTHER'
};

exports.AppointmentStatus = exports.$Enums.AppointmentStatus = {
  CREATED: 'CREATED',
  CANCELED: 'CANCELED',
  DELETED: 'DELETED',
  UNKNOWN: 'UNKNOWN'
};

exports.BundleTimeRangeHolidays = exports.$Enums.BundleTimeRangeHolidays = {
  INCLUDED: 'INCLUDED',
  ONLY: 'ONLY',
  EXCLUDED: 'EXCLUDED'
};

exports.PrestationType = exports.$Enums.PrestationType = {
  AMO: 'AMO',
  DEPLOYMENT: 'DEPLOYMENT',
  TRANING: 'TRANING',
  COPIL: 'COPIL',
  CONNECTOR_LINK: 'CONNECTOR_LINK',
  CONNECTOR_HL7: 'CONNECTOR_HL7',
  OTHER: 'OTHER'
};

exports.OptimTemplateStatus = exports.$Enums.OptimTemplateStatus = {
  TO_VALIDATE: 'TO_VALIDATE',
  TO_COMMUNICATE: 'TO_COMMUNICATE',
  TO_ACTIVATE: 'TO_ACTIVATE',
  ACTIVE: 'ACTIVE',
  DEPRECATED: 'DEPRECATED'
};

exports.WeekDay = exports.$Enums.WeekDay = {
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY'
};

exports.MtOption = exports.$Enums.MtOption = {
  MT1: 'MT1',
  MT2: 'MT2'
};

exports.ManualInvoiceDocumentField = exports.$Enums.ManualInvoiceDocumentField = {
  MT_NAME: 'MT_NAME',
  MT_SIRET: 'MT_SIRET',
  INVOICE_ID: 'INVOICE_ID',
  MF_NAME: 'MF_NAME',
  PATIENT_NAME: 'PATIENT_NAME',
  TRIP_DATE: 'TRIP_DATE',
  PRICE: 'PRICE',
  HAS_WAITING_FEE: 'HAS_WAITING_FEE',
  VAT_PERCENT: 'VAT_PERCENT',
  DISTANCE: 'DISTANCE',
  CERFA: 'CERFA'
};

exports.AllowedDepartureMarginType = exports.$Enums.AllowedDepartureMarginType = {
  PLUS_90: 'PLUS_90',
  PLUS_60: 'PLUS_60',
  PLUS_45: 'PLUS_45',
  NONE: 'NONE',
  PLUS_OR_MINUS_45: 'PLUS_OR_MINUS_45',
  PLUS_OR_MINUS_60: 'PLUS_OR_MINUS_60',
  PLUS_OR_MINUS_90: 'PLUS_OR_MINUS_90'
};

exports.AllowedArrivalMarginType = exports.$Enums.AllowedArrivalMarginType = {
  NONE: 'NONE',
  MINUS_45: 'MINUS_45',
  MINUS_60: 'MINUS_60',
  MINUS_90: 'MINUS_90'
};

exports.UserPermissionType = exports.$Enums.UserPermissionType = {
  BO_PATIENT_IDENTITY_READ: 'BO_PATIENT_IDENTITY_READ',
  BO_MANAGE_USERS: 'BO_MANAGE_USERS',
  BO_EXPORT_ANONYMOUS: 'BO_EXPORT_ANONYMOUS',
  BO_EXPORT_FULL: 'BO_EXPORT_FULL'
};

exports.TransfusionSubject = exports.$Enums.TransfusionSubject = {
  BOOKING_REQUEST: 'BOOKING_REQUEST'
};

exports.TransfusionEventType = exports.$Enums.TransfusionEventType = {
  CREATED: 'CREATED',
  ACCEPTED: 'ACCEPTED',
  REFUSED: 'REFUSED',
  CANCELED: 'CANCELED',
  ASSIGNED_TO_OTHER_CARRIER: 'ASSIGNED_TO_OTHER_CARRIER',
  PROPOSED_DATE: 'PROPOSED_DATE',
  ACKNOWLEDGEMENT_NEEDED: 'ACKNOWLEDGEMENT_NEEDED',
  UPDATED: 'UPDATED'
};

exports.TransfusionType = exports.$Enums.TransfusionType = {
  V1_TO_EXISTING_AMB: 'V1_TO_EXISTING_AMB',
  V2_TO_EXISTING_AMB: 'V2_TO_EXISTING_AMB',
  MANUAL_V2_TO_EXISTING_AMB: 'MANUAL_V2_TO_EXISTING_AMB',
  V1_TO_NEW_AMB: 'V1_TO_NEW_AMB',
  V2_TO_NEW_AMB: 'V2_TO_NEW_AMB',
  MANUAL_V2_TO_NEW_AMB: 'MANUAL_V2_TO_NEW_AMB'
};

exports.TransfusionStep = exports.$Enums.TransfusionStep = {
  INVITED: 'INVITED',
  REMINDED_ONCE: 'REMINDED_ONCE',
  REMINDED_TWICE: 'REMINDED_TWICE',
  ACTIVATED: 'ACTIVATED'
};

exports.SyncUserConfigMode = exports.$Enums.SyncUserConfigMode = {
  DIFFERENTIAL: 'DIFFERENTIAL',
  SNAPSHOT: 'SNAPSHOT'
};

exports.TransportMode = exports.$Enums.TransportMode = {
  TAP: 'TAP',
  AMB: 'AMB',
  TPMR: 'TPMR'
};

exports.SectorGroupType = exports.$Enums.SectorGroupType = {
  DEPARTEMENT: 'DEPARTEMENT',
  CUSTOM: 'CUSTOM'
};

exports.FleetVehicleType = exports.$Enums.FleetVehicleType = {
  VSL: 'VSL',
  TAXI: 'TAXI',
  AMBULANCE: 'AMBULANCE',
  TPMR: 'TPMR',
  BARIATRIC: 'BARIATRIC',
  PARAMEDICAL: 'PARAMEDICAL',
  MEDICAL: 'MEDICAL'
};

exports.StretcherModPatientFieldState = exports.$Enums.StretcherModPatientFieldState = {
  USED: 'USED',
  USED_AND_REQUIRED: 'USED_AND_REQUIRED',
  UNUSED: 'UNUSED'
};

exports.StretcherModVehicleType = exports.$Enums.StretcherModVehicleType = {
  WALKING: 'WALKING',
  STRETCHER: 'STRETCHER',
  BARIATRIC_STRETCHER: 'BARIATRIC_STRETCHER',
  MEDICAL_BED: 'MEDICAL_BED',
  ALZHEIMER_BED: 'ALZHEIMER_BED',
  WHEELCHAIR: 'WHEELCHAIR'
};

exports.StretcherModPatientSpecificNeedType = exports.$Enums.StretcherModPatientSpecificNeedType = {
  WHEELCHAIR: 'WHEELCHAIR',
  PROTECTIVE_ISOLATION: 'PROTECTIVE_ISOLATION',
  OXYGEN: 'OXYGEN',
  VACUUM_MATTRESS: 'VACUUM_MATTRESS',
  SYRINGE_PUMP: 'SYRINGE_PUMP',
  INCUBATOR: 'INCUBATOR',
  MONITOR: 'MONITOR'
};

exports.StretcherModPatientConditionType = exports.$Enums.StretcherModPatientConditionType = {
  CONTAGIOUS: 'CONTAGIOUS',
  PAIN_OR_DISCOMFORT: 'PAIN_OR_DISCOMFORT',
  CONTACT_ISOLATION: 'CONTACT_ISOLATION',
  NEWBORN_OR_CHILD: 'NEWBORN_OR_CHILD',
  AGITATED: 'AGITATED',
  DISORIENTED: 'DISORIENTED',
  ON_INFUSION: 'ON_INFUSION',
  PREMATURE: 'PREMATURE',
  OVERWEIGHT: 'OVERWEIGHT'
};

exports.StretcherModTransportReasonType = exports.$Enums.StretcherModTransportReasonType = {
  CONSULTATION: 'CONSULTATION',
  IMAGING: 'IMAGING',
  OPERATING_ROOM: 'OPERATING_ROOM',
  EMERGENCY: 'EMERGENCY',
  RETURN_TO_ROOM: 'RETURN_TO_ROOM',
  ONCOLOGY_DIALYSIS: 'ONCOLOGY_DIALYSIS',
  DEPARTMENT_CHANGE: 'DEPARTMENT_CHANGE',
  DAY_HOSPITAL: 'DAY_HOSPITAL',
  OTHER: 'OTHER'
};

exports.StretcherModOrderStatus = exports.$Enums.StretcherModOrderStatus = {
  CREATED: 'CREATED',
  CONFIRMED: 'CONFIRMED',
  ABORTED: 'ABORTED'
};

exports.StretcherModTimeReference = exports.$Enums.StretcherModTimeReference = {
  DEPARTURE: 'DEPARTURE',
  ARRIVAL: 'ARRIVAL',
  UNKNOWN: 'UNKNOWN'
};

exports.StretcherModUnitRole = exports.$Enums.StretcherModUnitRole = {
  REGULATOR: 'REGULATOR',
  BEARER: 'BEARER'
};

exports.StretcherModSegmentStatus = exports.$Enums.StretcherModSegmentStatus = {
  CREATED: 'CREATED',
  DISPATCHING: 'DISPATCHING',
  UNIT_NOT_FOUND: 'UNIT_NOT_FOUND',
  BOOKED: 'BOOKED',
  RUNNING: 'RUNNING',
  ARRIVED: 'ARRIVED',
  CONFIRMED: 'CONFIRMED',
  CANCELED: 'CANCELED'
};

exports.StretcherModSegmentEventStatus = exports.$Enums.StretcherModSegmentEventStatus = {
  CREATED: 'CREATED',
  DISPATCHING: 'DISPATCHING',
  UNIT_NOT_FOUND: 'UNIT_NOT_FOUND',
  BOOKED: 'BOOKED',
  RUNNING: 'RUNNING',
  ARRIVED: 'ARRIVED',
  CONFIRMED: 'CONFIRMED',
  CANCELED: 'CANCELED',
  SENT: 'SENT',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  RESCHEDULED: 'RESCHEDULED',
  DRIVER_ASSIGNED: 'DRIVER_ASSIGNED',
  DRIVER_UNASSIGNED: 'DRIVER_UNASSIGNED'
};

exports.StretcherModEventStatusType = exports.$Enums.StretcherModEventStatusType = {
  REGULAR: 'REGULAR',
  FLASH: 'FLASH',
  LOG: 'LOG'
};

exports.StretcherModDriverEventType = exports.$Enums.StretcherModDriverEventType = {
  START: 'START',
  AT_ORIGIN: 'AT_ORIGIN',
  PICK_UP: 'PICK_UP',
  AT_DESTINATION: 'AT_DESTINATION',
  DROP_OFF: 'DROP_OFF',
  END: 'END'
};

exports.Prisma.ModelName = {
  A4cContractPaymentStatus: 'A4cContractPaymentStatus',
  A4cContract: 'A4cContract',
  Address: 'Address',
  AssociatedMedicalTransporter: 'AssociatedMedicalTransporter',
  BookingRequest: 'BookingRequest',
  BrowserExtensionConfig: 'BrowserExtensionConfig',
  Bundle: 'Bundle',
  BundleMtRule: 'BundleMtRule',
  BundleRule: 'BundleRule',
  CancelOrder: 'CancelOrder',
  ChangeRequest: 'ChangeRequest',
  CreditNote: 'CreditNote',
  AllowPreferredMtForPayer: 'AllowPreferredMtForPayer',
  Customization: 'Customization',
  Device: 'Device',
  DistanceMap: 'DistanceMap',
  DistanceMapEntry: 'DistanceMapEntry',
  Doctor: 'Doctor',
  DriverEvent: 'DriverEvent',
  ElisaConfig: 'ElisaConfig',
  OptOut: 'OptOut',
  EmailAddress: 'EmailAddress',
  ExportRequest: 'ExportRequest',
  ExportRequestOutput: 'ExportRequestOutput',
  FinessMedicalFacility: 'FinessMedicalFacility',
  FlatFee: 'FlatFee',
  GlobalStoreEntry: 'GlobalStoreEntry',
  Invoice: 'Invoice',
  InvoiceEvent: 'InvoiceEvent',
  InvoicePassengerBlock: 'InvoicePassengerBlock',
  InvoiceTripBlock: 'InvoiceTripBlock',
  ManualInvoice: 'ManualInvoice',
  ManualInvoiceEvent: 'ManualInvoiceEvent',
  MedicalFacility: 'MedicalFacility',
  MedicalFacilityDepartment: 'MedicalFacilityDepartment',
  MedicalFacilityApiScope: 'MedicalFacilityApiScope',
  MedicalFacilityGroup: 'MedicalFacilityGroup',
  MedicalFacilityGroupAcl: 'MedicalFacilityGroupAcl',
  MedicalFacilityUnit: 'MedicalFacilityUnit',
  MedicalTransporter: 'MedicalTransporter',
  MedicalTransporterAcl: 'MedicalTransporterAcl',
  MedicalTransporterReport: 'MedicalTransporterReport',
  MedicalTransporterReview: 'MedicalTransporterReview',
  Mission: 'Mission',
  MissionEvent: 'MissionEvent',
  IncludedPassengerStatus: 'IncludedPassengerStatus',
  ExcludedPassengerId: 'ExcludedPassengerId',
  OptimizationRequest: 'OptimizationRequest',
  OptimizationRequestRow: 'OptimizationRequestRow',
  Order: 'Order',
  OrderItem: 'OrderItem',
  OrderPatient: 'OrderPatient',
  OrderRide: 'OrderRide',
  Passenger: 'Passenger',
  PassengerChange: 'PassengerChange',
  PassengerEvent: 'PassengerEvent',
  PassengerIncident: 'PassengerIncident',
  PassengerPriceOverride: 'PassengerPriceOverride',
  Patient: 'Patient',
  Place: 'Place',
  Prescription: 'Prescription',
  PriceAgreement: 'PriceAgreement',
  PriceInfo: 'PriceInfo',
  PricingVehicle: 'PricingVehicle',
  Pricing: 'Pricing',
  PtahConfig: 'PtahConfig',
  PtahInfo: 'PtahInfo',
  Raven: 'Raven',
  RobotConfig: 'RobotConfig',
  ShortTripFeeTier: 'ShortTripFeeTier',
  SihMovement: 'SihMovement',
  SihPatient: 'SihPatient',
  SihVisit: 'SihVisit',
  Task: 'Task',
  TdrContract: 'TdrContract',
  ThirdPartyPassenger: 'ThirdPartyPassenger',
  TrafficControlMetric: 'TrafficControlMetric',
  TransportReasonCustomization: 'TransportReasonCustomization',
  TransportReasonCustomizationGroup: 'TransportReasonCustomizationGroup',
  Trip: 'Trip',
  TripPriceOverride: 'TripPriceOverride',
  User: 'User',
  UserMfuAcl: 'UserMfuAcl',
  UserMfuAclSignatureRight: 'UserMfuAclSignatureRight',
  VehicleCustomization: 'VehicleCustomization',
  VehicleCustomizationField: 'VehicleCustomizationField',
  Zone: 'Zone',
  ZoneMap: 'ZoneMap',
  AmblerInvoice: 'AmblerInvoice',
  BookingRequestEvent: 'BookingRequestEvent',
  BrTcNote: 'BrTcNote',
  InseeFlatFeeType: 'InseeFlatFeeType',
  MedicalTransporterReviewRequestedChange: 'MedicalTransporterReviewRequestedChange',
  MedicalTransporterReviewRequestedChangeEvent: 'MedicalTransporterReviewRequestedChangeEvent',
  PostApprovalInvoiceModification: 'PostApprovalInvoiceModification',
  WeeklyMetric: 'WeeklyMetric',
  AmblerInvoiceEvent: 'AmblerInvoiceEvent',
  AmblerInvoicingModificationRequest: 'AmblerInvoicingModificationRequest',
  AmblerCreditNote: 'AmblerCreditNote',
  SuperSizedPlace: 'SuperSizedPlace',
  PassengerCancelation: 'PassengerCancelation',
  A4hlContract: 'A4hlContract',
  SihAppointment: 'SihAppointment',
  A4hsContract: 'A4hsContract',
  AldContract: 'AldContract',
  BundlePayer: 'BundlePayer',
  BundleTransportReason: 'BundleTransportReason',
  BundleTimeRange: 'BundleTimeRange',
  Prestation: 'Prestation',
  Appointment: 'Appointment',
  OptimTemplate: 'OptimTemplate',
  OptimTemplateDay: 'OptimTemplateDay',
  PatientConfig: 'PatientConfig',
  ManualInvoiceDocumentError: 'ManualInvoiceDocumentError',
  PreferredMtCustomizationRule: 'PreferredMtCustomizationRule',
  PreferredMtCustomizationRulePayer: 'PreferredMtCustomizationRulePayer',
  SpeedCallApiKeyMapping: 'SpeedCallApiKeyMapping',
  SpeedCallRelationKeyMapping: 'SpeedCallRelationKeyMapping',
  AlternativeMedicalFacilityName: 'AlternativeMedicalFacilityName',
  UserPermission: 'UserPermission',
  ViaMichelinDistanceMapEntry: 'ViaMichelinDistanceMapEntry',
  TransfusionEvent: 'TransfusionEvent',
  SpeedCallMedicalTransporter: 'SpeedCallMedicalTransporter',
  SyncUserConfig: 'SyncUserConfig',
  HprimConfig: 'HprimConfig',
  MtSector: 'MtSector',
  Sector: 'Sector',
  SectorGroup: 'SectorGroup',
  FleetConfig: 'FleetConfig',
  FleetDriver: 'FleetDriver',
  FleetMission: 'FleetMission',
  FleetVehicle: 'FleetVehicle',
  Township: 'Township',
  PreconfiguredTdr: 'PreconfiguredTdr',
  StretcherModCustomization: 'StretcherModCustomization',
  StretcherModVehicle: 'StretcherModVehicle',
  StretcherModPatientSpecificNeed: 'StretcherModPatientSpecificNeed',
  StretcherModPatientCondition: 'StretcherModPatientCondition',
  StretcherModTransportReasonGroup: 'StretcherModTransportReasonGroup',
  StretcherModTransportReason: 'StretcherModTransportReason',
  StretcherModRouteConfig: 'StretcherModRouteConfig',
  StretcherModRoute: 'StretcherModRoute',
  StretcherModOrder: 'StretcherModOrder',
  StretcherModOrderStep: 'StretcherModOrderStep',
  StretcherModOrderStepSpecificNeed: 'StretcherModOrderStepSpecificNeed',
  StretcherModOrderStepPatientCondition: 'StretcherModOrderStepPatientCondition',
  StretcherModSegmentSpecificNeed: 'StretcherModSegmentSpecificNeed',
  StretcherModSegmentPatientCondition: 'StretcherModSegmentPatientCondition',
  StretcherModSegmentDriver: 'StretcherModSegmentDriver',
  StretcherModUnit: 'StretcherModUnit',
  StretcherModUnitAcl: 'StretcherModUnitAcl',
  StretcherModDriver: 'StretcherModDriver',
  StretcherModSegment: 'StretcherModSegment',
  StretcherModSegmentEvent: 'StretcherModSegmentEvent',
  StretcherModDriverEvent: 'StretcherModDriverEvent',
  AuthSession: 'AuthSession'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
